[
  {
    "code": "MX-YUC-001",
    "name": "Abalá"
  },
  {
    "code": "MX-GUA-001",
    "name": "Abasolo"
  },
  {
    "code": "MX-NLE-001",
    "name": "Abasolo"
  },
  {
    "code": "MX-COA-001",
    "name": "Abasolo"
  },
  {
    "code": "MX-TAM-001",
    "name": "Abasolo"
  },
  {
    "code": "MX-CHP-001",
    "name": "Acacoyagua"
  },
  {
    "code": "MX-VER-001",
    "name": "Acajete"
  },
  {
    "code": "MX-PUE-001",
    "name": "Acajete"
  },
  {
    "code": "MX-CHP-002",
    "name": "Acala"
  },
  {
    "code": "MX-MEX-001",
    "name": "Acambay"
  },
  {
    "code": "MX-YUC-002",
    "name": "Acanceh"
  },
  {
    "code": "MX-CHP-003",
    "name": "Acapetahua"
  },
  {
    "code": "MX-NAY-001",
    "name": "Acaponeta"
  },
  {
    "code": "MX-GRO-001",
    "name": "Acapulco"
  },
  {
    "code": "MX-PUE-002",
    "name": "Acateno"
  },
  {
    "code": "MX-GRO-002",
    "name": "Acatepec"
  },
  {
    "code": "MX-JAL-001",
    "name": "Acatic"
  },
  {
    "code": "MX-VER-002",
    "name": "Acatlán"
  },
  {
    "code": "MX-PUE-003",
    "name": "Acatlán"
  },
  {
    "code": "MX-HID-001",
    "name": "Acatlán"
  },
  {
    "code": "MX-JAL-002",
    "name": "Acatlán de Juárez"
  },
  {
    "code": "MX-PUE-004",
    "name": "Acatzingo"
  },
  {
    "code": "MX-HID-002",
    "name": "Acaxochitlán"
  },
  {
    "code": "MX-VER-003",
    "name": "Acayucan"
  },
  {
    "code": "MX-MEX-002",
    "name": "Acolman"
  },
  {
    "code": "MX-SON-001",
    "name": "Aconchi"
  },
  {
    "code": "MX-PUE-005",
    "name": "Acteopan"
  },
  {
    "code": "MX-VER-004",
    "name": "Actopan"
  },
  {
    "code": "MX-HID-003",
    "name": "Actopan"
  },
  {
    "code": "MX-TLA-001",
    "name": "Acuamanala de Miguel Hidalgo"
  },
  {
    "code": "MX-MIC-001",
    "name": "Acuitzio"
  },
  {
    "code": "MX-VER-005",
    "name": "Acula"
  },
  {
    "code": "MX-MEX-003",
    "name": "Aculco"
  },
  {
    "code": "MX-VER-006",
    "name": "Acultzingo"
  },
  {
    "code": "MX-COA-002",
    "name": "Acuña"
  },
  {
    "code": "MX-GUA-002",
    "name": "Acámbaro"
  },
  {
    "code": "MX-HID-004",
    "name": "Agua Blanca de Iturbide"
  },
  {
    "code": "MX-VER-007",
    "name": "Agua Dulce"
  },
  {
    "code": "MX-SON-002",
    "name": "Agua Prieta"
  },
  {
    "code": "MX-NLE-002",
    "name": "Agualeguas"
  },
  {
    "code": "MX-AGU-001",
    "name": "Aguascalientes"
  },
  {
    "code": "MX-MIC-002",
    "name": "Aguililla"
  },
  {
    "code": "MX-SIN-001",
    "name": "Ahome"
  },
  {
    "code": "MX-PUE-006",
    "name": "Ahuacatlán"
  },
  {
    "code": "MX-NAY-002",
    "name": "Ahuacatlán"
  },
  {
    "code": "MX-GRO-003",
    "name": "Ahuacuotzingo"
  },
  {
    "code": "MX-SLP-001",
    "name": "Ahualulco"
  },
  {
    "code": "MX-JAL-003",
    "name": "Ahualulco de Mercado"
  },
  {
    "code": "MX-PUE-007",
    "name": "Ahuatlán"
  },
  {
    "code": "MX-PUE-008",
    "name": "Ahuazotepec"
  },
  {
    "code": "MX-PUE-009",
    "name": "Ahuehuetitla"
  },
  {
    "code": "MX-CHH-001",
    "name": "Ahumada"
  },
  {
    "code": "MX-HID-005",
    "name": "Ajacuba"
  },
  {
    "code": "MX-PUE-010",
    "name": "Ajalpan"
  },
  {
    "code": "MX-GRO-004",
    "name": "Ajuchitlán del Progreso"
  },
  {
    "code": "MX-YUC-003",
    "name": "Akil"
  },
  {
    "code": "MX-SON-003",
    "name": "Alamos"
  },
  {
    "code": "MX-SLP-002",
    "name": "Alaquines"
  },
  {
    "code": "MX-PUE-011",
    "name": "Albino Zertuche"
  },
  {
    "code": "MX-GRO-005",
    "name": "Alcozauca de Guerrero"
  },
  {
    "code": "MX-CHH-002",
    "name": "Aldama"
  },
  {
    "code": "MX-TAM-002",
    "name": "Aldama"
  },
  {
    "code": "MX-CHP-004",
    "name": "Aldama"
  },
  {
    "code": "MX-HID-006",
    "name": "Alfajayucan"
  },
  {
    "code": "MX-PUE-012",
    "name": "Aljojuca"
  },
  {
    "code": "MX-CHH-003",
    "name": "Allende"
  },
  {
    "code": "MX-NLE-003",
    "name": "Allende"
  },
  {
    "code": "MX-COA-003",
    "name": "Allende"
  },
  {
    "code": "MX-HID-007",
    "name": "Almoloya"
  },
  {
    "code": "MX-MEX-004",
    "name": "Almoloya de Alquisiras"
  },
  {
    "code": "MX-MEX-005",
    "name": "Almoloya de Juárez"
  },
  {
    "code": "MX-MEX-006",
    "name": "Almoloya del Río"
  },
  {
    "code": "MX-VER-008",
    "name": "Alpatláhuac"
  },
  {
    "code": "MX-GRO-006",
    "name": "Alpoyeca"
  },
  {
    "code": "MX-TAM-003",
    "name": "Altamira"
  },
  {
    "code": "MX-CHP-005",
    "name": "Altamirano"
  },
  {
    "code": "MX-SON-004",
    "name": "Altar"
  },
  {
    "code": "MX-PUE-013",
    "name": "Altepexi"
  },
  {
    "code": "MX-VER-009",
    "name": "Alto Lucero"
  },
  {
    "code": "MX-VER-010",
    "name": "Altotonga"
  },
  {
    "code": "MX-TLA-006",
    "name": "Altzayanca"
  },
  {
    "code": "MX-VER-011",
    "name": "Alvarado"
  },
  {
    "code": "MX-JAL-004",
    "name": "Amacueca"
  },
  {
    "code": "MX-MOR-001",
    "name": "Amacuzac"
  },
  {
    "code": "MX-MEX-007",
    "name": "Amanalco"
  },
  {
    "code": "MX-CHP-006",
    "name": "Amatenango de la Frontera"
  },
  {
    "code": "MX-CHP-007",
    "name": "Amatenango del Valle"
  },
  {
    "code": "MX-MEX-008",
    "name": "Amatepec"
  },
  {
    "code": "MX-VER-012",
    "name": "Amatitlán"
  },
  {
    "code": "MX-JAL-005",
    "name": "Amatitán"
  },
  {
    "code": "MX-NAY-003",
    "name": "Amatlán de Cañas"
  },
  {
    "code": "MX-VER-013",
    "name": "Amatlán de los Reyes"
  },
  {
    "code": "MX-CHP-008",
    "name": "Amatán"
  },
  {
    "code": "MX-TLA-002",
    "name": "Amaxac de Guerrero"
  },
  {
    "code": "MX-QUE-001",
    "name": "Amealco de Bonfil"
  },
  {
    "code": "MX-JAL-006",
    "name": "Ameca"
  },
  {
    "code": "MX-MEX-009",
    "name": "Amecameca"
  },
  {
    "code": "MX-PUE-014",
    "name": "Amixtlán"
  },
  {
    "code": "MX-PUE-015",
    "name": "Amozoc"
  },
  {
    "code": "MX-MIC-003",
    "name": "Angamacutiro"
  },
  {
    "code": "MX-MIC-004",
    "name": "Angangueo"
  },
  {
    "code": "MX-CHP-009",
    "name": "Angel Albino Corzo"
  },
  {
    "code": "MX-VER-014",
    "name": "Angel R. Cabada"
  },
  {
    "code": "MX-SIN-002",
    "name": "Angostura"
  },
  {
    "code": "MX-TAM-004",
    "name": "Antiguo Morelos"
  },
  {
    "code": "MX-NLE-004",
    "name": "Anáhuac"
  },
  {
    "code": "MX-HID-008",
    "name": "Apan"
  },
  {
    "code": "MX-GUA-003",
    "name": "Apaseo el Alto"
  },
  {
    "code": "MX-GUA-004",
    "name": "Apaseo el Grande"
  },
  {
    "code": "MX-MIC-005",
    "name": "Apatzingán"
  },
  {
    "code": "MX-MEX-010",
    "name": "Apaxco"
  },
  {
    "code": "MX-GRO-007",
    "name": "Apaxtla"
  },
  {
    "code": "MX-VER-015",
    "name": "Apazapan"
  },
  {
    "code": "MX-TLA-003",
    "name": "Apetatitlán de Antonio Carvajal"
  },
  {
    "code": "MX-TLA-004",
    "name": "Apizaco"
  },
  {
    "code": "MX-NLE-005",
    "name": "Apodaca"
  },
  {
    "code": "MX-MIC-006",
    "name": "Aporo"
  },
  {
    "code": "MX-ZAC-001",
    "name": "Apozol"
  },
  {
    "code": "MX-ZAC-002",
    "name": "Apulco"
  },
  {
    "code": "MX-VER-016",
    "name": "Aquila"
  },
  {
    "code": "MX-MIC-007",
    "name": "Aquila"
  },
  {
    "code": "MX-CHH-004",
    "name": "Aquiles Serdán"
  },
  {
    "code": "MX-SLP-003",
    "name": "Aquismón"
  },
  {
    "code": "MX-PUE-016",
    "name": "Aquixtla"
  },
  {
    "code": "MX-NLE-006",
    "name": "Aramberri"
  },
  {
    "code": "MX-JAL-007",
    "name": "Arandas"
  },
  {
    "code": "MX-GRO-008",
    "name": "Arcelia"
  },
  {
    "code": "MX-MIC-008",
    "name": "Ario"
  },
  {
    "code": "MX-SON-005",
    "name": "Arivechi"
  },
  {
    "code": "MX-SON-006",
    "name": "Arizpe"
  },
  {
    "code": "MX-SLP-004",
    "name": "Armadillo de los Infante"
  },
  {
    "code": "MX-COL-001",
    "name": "Armería"
  },
  {
    "code": "MX-CHP-010",
    "name": "Arriaga"
  },
  {
    "code": "MX-QUE-002",
    "name": "Arroyo Seco"
  },
  {
    "code": "MX-MIC-009",
    "name": "Arteaga"
  },
  {
    "code": "MX-COA-004",
    "name": "Arteaga"
  },
  {
    "code": "MX-CHH-005",
    "name": "Ascensión"
  },
  {
    "code": "MX-AGU-002",
    "name": "Asientos"
  },
  {
    "code": "MX-VER-017",
    "name": "Astacinga"
  },
  {
    "code": "MX-GUA-005",
    "name": "Atarjea"
  },
  {
    "code": "MX-JAL-008",
    "name": "Atemajac de Brizuela"
  },
  {
    "code": "MX-PUE-017",
    "name": "Atempan"
  },
  {
    "code": "MX-GRO-009",
    "name": "Atenango del Río"
  },
  {
    "code": "MX-MEX-011",
    "name": "Atenco"
  },
  {
    "code": "MX-JAL-009",
    "name": "Atengo"
  },
  {
    "code": "MX-JAL-010",
    "name": "Atenguillo"
  },
  {
    "code": "MX-PUE-018",
    "name": "Atexcal"
  },
  {
    "code": "MX-SON-007",
    "name": "Atil"
  },
  {
    "code": "MX-HID-009",
    "name": "Atitalaquia"
  },
  {
    "code": "MX-MEX-012",
    "name": "Atizapán"
  },
  {
    "code": "MX-MEX-013",
    "name": "Atizapán de Zaragoza"
  },
  {
    "code": "MX-MEX-014",
    "name": "Atlacomulco"
  },
  {
    "code": "MX-VER-018",
    "name": "Atlahuilco"
  },
  {
    "code": "MX-GRO-010",
    "name": "Atlamajalcingo del Monte"
  },
  {
    "code": "MX-TLA-005",
    "name": "Atlangatepec"
  },
  {
    "code": "MX-HID-010",
    "name": "Atlapexco"
  },
  {
    "code": "MX-MOR-002",
    "name": "Atlatlahucan"
  },
  {
    "code": "MX-MEX-015",
    "name": "Atlautla"
  },
  {
    "code": "MX-PUE-019",
    "name": "Atlequizayan"
  },
  {
    "code": "MX-PUE-020",
    "name": "Atlixco"
  },
  {
    "code": "MX-GRO-011",
    "name": "Atlixtac"
  },
  {
    "code": "MX-ZAC-003",
    "name": "Atolinga"
  },
  {
    "code": "MX-HID-011",
    "name": "Atotonilco de Tula"
  },
  {
    "code": "MX-JAL-011",
    "name": "Atotonilco el Alto"
  },
  {
    "code": "MX-HID-012",
    "name": "Atotonilco el Grande"
  },
  {
    "code": "MX-VER-019",
    "name": "Atoyac"
  },
  {
    "code": "MX-JAL-012",
    "name": "Atoyac"
  },
  {
    "code": "MX-GRO-012",
    "name": "Atoyac de Álvarez"
  },
  {
    "code": "MX-PUE-021",
    "name": "Atoyatempan"
  },
  {
    "code": "MX-VER-020",
    "name": "Atzacan"
  },
  {
    "code": "MX-PUE-022",
    "name": "Atzala"
  },
  {
    "code": "MX-VER-021",
    "name": "Atzalan"
  },
  {
    "code": "MX-PUE-023",
    "name": "Atzitzihuacán"
  },
  {
    "code": "MX-PUE-024",
    "name": "Atzitzintla"
  },
  {
    "code": "MX-JAL-013",
    "name": "Autlán de Navarro"
  },
  {
    "code": "MX-MEX-016",
    "name": "Axapusco"
  },
  {
    "code": "MX-MOR-003",
    "name": "Axochiapan"
  },
  {
    "code": "MX-SLP-005",
    "name": "Axtla de Terrazas"
  },
  {
    "code": "MX-PUE-025",
    "name": "Axutla"
  },
  {
    "code": "MX-VER-022",
    "name": "Ayahualulco"
  },
  {
    "code": "MX-MOR-004",
    "name": "Ayala"
  },
  {
    "code": "MX-MEX-017",
    "name": "Ayapango"
  },
  {
    "code": "MX-JAL-014",
    "name": "Ayotlán"
  },
  {
    "code": "MX-PUE-026",
    "name": "Ayotoxco de Guerrero"
  },
  {
    "code": "MX-JAL-015",
    "name": "Ayutla"
  },
  {
    "code": "MX-GRO-013",
    "name": "Ayutla de los Libres"
  },
  {
    "code": "MX-DIF-001",
    "name": "Azcapotzalco"
  },
  {
    "code": "MX-GRO-014",
    "name": "Azoyú"
  },
  {
    "code": "MX-YUC-004",
    "name": "Baca"
  },
  {
    "code": "MX-SON-008",
    "name": "Bacadéhuachi"
  },
  {
    "code": "MX-ROO-010",
    "name": "Bacalar"
  },
  {
    "code": "MX-SON-009",
    "name": "Bacanora"
  },
  {
    "code": "MX-SON-010",
    "name": "Bacerac"
  },
  {
    "code": "MX-CHH-006",
    "name": "Bachíniva"
  },
  {
    "code": "MX-SON-011",
    "name": "Bacoachi"
  },
  {
    "code": "MX-SIN-003",
    "name": "Badiraguato"
  },
  {
    "code": "MX-NAY-004",
    "name": "Bahía de Banderas"
  },
  {
    "code": "MX-TAB-001",
    "name": "Balancán"
  },
  {
    "code": "MX-CHH-007",
    "name": "Balleza"
  },
  {
    "code": "MX-VER-023",
    "name": "Banderilla"
  },
  {
    "code": "MX-SON-012",
    "name": "Banámichi"
  },
  {
    "code": "MX-CHH-008",
    "name": "Batopilas"
  },
  {
    "code": "MX-SON-013",
    "name": "Bavispe"
  },
  {
    "code": "MX-SON-014",
    "name": "Baviácora"
  },
  {
    "code": "MX-CHP-011",
    "name": "Bejucal de Ocampo"
  },
  {
    "code": "MX-CHP-012",
    "name": "Bella Vista"
  },
  {
    "code": "MX-CHP-013",
    "name": "Benemérito de las Américas"
  },
  {
    "code": "MX-VER-024",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-DIF-002",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-ZAC-004",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-GRO-015",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-ROO-001",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-TLA-007",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-SON-015",
    "name": "Benito Juárez"
  },
  {
    "code": "MX-SON-016",
    "name": "Benjamín Hill"
  },
  {
    "code": "MX-CHP-014",
    "name": "Berriozábal"
  },
  {
    "code": "MX-VER-025",
    "name": "Boca del Río"
  },
  {
    "code": "MX-CHP-015",
    "name": "Bochil"
  },
  {
    "code": "MX-CHH-009",
    "name": "Bocoyna"
  },
  {
    "code": "MX-YUC-005",
    "name": "Bokobá"
  },
  {
    "code": "MX-JAL-016",
    "name": "Bolaños"
  },
  {
    "code": "MX-MIC-010",
    "name": "Briseñas"
  },
  {
    "code": "MX-YUC-006",
    "name": "Buctzotz"
  },
  {
    "code": "MX-CHH-010",
    "name": "Buenaventura"
  },
  {
    "code": "MX-MIC-011",
    "name": "Buenavista"
  },
  {
    "code": "MX-GRO-016",
    "name": "Buenavista de Cuéllar"
  },
  {
    "code": "MX-TAM-005",
    "name": "Burgos"
  },
  {
    "code": "MX-NLE-007",
    "name": "Bustamante"
  },
  {
    "code": "MX-TAM-006",
    "name": "Bustamante"
  },
  {
    "code": "MX-SON-017",
    "name": "Bácum"
  },
  {
    "code": "MX-JAL-017",
    "name": "Cabo Corrientes"
  },
  {
    "code": "MX-SON-018",
    "name": "Caborca"
  },
  {
    "code": "MX-CHP-016",
    "name": "Cacahoatán"
  },
  {
    "code": "MX-YUC-007",
    "name": "Cacalchén"
  },
  {
    "code": "MX-QUE-003",
    "name": "Cadereyta de Montes"
  },
  {
    "code": "MX-NLE-008",
    "name": "Cadereyta Jiménez"
  },
  {
    "code": "MX-SON-019",
    "name": "Cajeme"
  },
  {
    "code": "MX-CAM-001",
    "name": "Calakmul"
  },
  {
    "code": "MX-VER-026",
    "name": "Calcahualco"
  },
  {
    "code": "MX-ZAC-005",
    "name": "Calera"
  },
  {
    "code": "MX-MEX-018",
    "name": "Calimaya"
  },
  {
    "code": "MX-CAM-002",
    "name": "Calkiní"
  },
  {
    "code": "MX-HID-013",
    "name": "Calnali"
  },
  {
    "code": "MX-YUC-008",
    "name": "Calotmul"
  },
  {
    "code": "MX-PUE-027",
    "name": "Calpan"
  },
  {
    "code": "MX-TLA-008",
    "name": "Calpulalpan"
  },
  {
    "code": "MX-PUE-028",
    "name": "Caltepec"
  },
  {
    "code": "MX-AGU-003",
    "name": "Calvillo"
  },
  {
    "code": "MX-CHH-011",
    "name": "Camargo"
  },
  {
    "code": "MX-TAM-007",
    "name": "Camargo"
  },
  {
    "code": "MX-VER-027",
    "name": "Camarón de Tejeda"
  },
  {
    "code": "MX-VER-028",
    "name": "Camerino Z. Mendoza"
  },
  {
    "code": "MX-PUE-029",
    "name": "Camocuautla"
  },
  {
    "code": "MX-CAM-003",
    "name": "Campeche"
  },
  {
    "code": "MX-SON-020",
    "name": "Cananea"
  },
  {
    "code": "MX-DUR-001",
    "name": "Canatlán"
  },
  {
    "code": "MX-COA-005",
    "name": "Candela"
  },
  {
    "code": "MX-CAM-004",
    "name": "Candelaria"
  },
  {
    "code": "MX-DUR-002",
    "name": "Canelas"
  },
  {
    "code": "MX-YUC-009",
    "name": "Cansahcab"
  },
  {
    "code": "MX-YUC-010",
    "name": "Cantamayec"
  },
  {
    "code": "MX-MEX-019",
    "name": "Capulhuac"
  },
  {
    "code": "MX-SON-021",
    "name": "Carbó"
  },
  {
    "code": "MX-HID-014",
    "name": "Cardonal"
  },
  {
    "code": "MX-CHH-012",
    "name": "Carichí"
  },
  {
    "code": "MX-VER-029",
    "name": "Carlos A. Carrillo"
  },
  {
    "code": "MX-NLE-009",
    "name": "Carmen"
  },
  {
    "code": "MX-CAM-005",
    "name": "Carmen"
  },
  {
    "code": "MX-VER-030",
    "name": "Carrillo Puerto"
  },
  {
    "code": "MX-MIC-012",
    "name": "Carácuaro"
  },
  {
    "code": "MX-TAM-008",
    "name": "Casas"
  },
  {
    "code": "MX-CHH-013",
    "name": "Casas Grandes"
  },
  {
    "code": "MX-JAL-018",
    "name": "Casimiro Castillo"
  },
  {
    "code": "MX-COA-006",
    "name": "Castaños"
  },
  {
    "code": "MX-VER-031",
    "name": "Castillo de Teayo"
  },
  {
    "code": "MX-CHP-017",
    "name": "Catazajá"
  },
  {
    "code": "MX-VER-032",
    "name": "Catemaco"
  },
  {
    "code": "MX-SLP-006",
    "name": "Catorce"
  },
  {
    "code": "MX-PUE-030",
    "name": "Caxhuacan"
  },
  {
    "code": "MX-VER-033",
    "name": "Cazones de Herrera"
  },
  {
    "code": "MX-PUE-031",
    "name": "Cañada Morelos"
  },
  {
    "code": "MX-JAL-019",
    "name": "Cañadas de Obregón"
  },
  {
    "code": "MX-ZAC-006",
    "name": "Cañitas de Felipe Pescador"
  },
  {
    "code": "MX-SLP-007",
    "name": "Cedral"
  },
  {
    "code": "MX-GUA-006",
    "name": "Celaya"
  },
  {
    "code": "MX-YUC-011",
    "name": "Celestún"
  },
  {
    "code": "MX-YUC-012",
    "name": "Cenotillo"
  },
  {
    "code": "MX-TAB-002",
    "name": "Centla"
  },
  {
    "code": "MX-TAB-003",
    "name": "Centro"
  },
  {
    "code": "MX-OAX-001",
    "name": "Centro"
  },
  {
    "code": "MX-NLE-010",
    "name": "Cerralvo"
  },
  {
    "code": "MX-SLP-008",
    "name": "Cerritos"
  },
  {
    "code": "MX-VER-034",
    "name": "Cerro Azul"
  },
  {
    "code": "MX-SLP-009",
    "name": "Cerro de San Pedro"
  },
  {
    "code": "MX-VER-035",
    "name": "Chacaltianguis"
  },
  {
    "code": "MX-YUC-013",
    "name": "Chacsinkín"
  },
  {
    "code": "MX-PUE-032",
    "name": "Chalchicomula de Sesma"
  },
  {
    "code": "MX-ZAC-007",
    "name": "Chalchihuites"
  },
  {
    "code": "MX-CHP-018",
    "name": "Chalchihuitán"
  },
  {
    "code": "MX-VER-036",
    "name": "Chalma"
  },
  {
    "code": "MX-CAM-006",
    "name": "Champotón"
  },
  {
    "code": "MX-CHP-019",
    "name": "Chamula"
  },
  {
    "code": "MX-CHP-020",
    "name": "Chanal"
  },
  {
    "code": "MX-YUC-014",
    "name": "Chankom"
  },
  {
    "code": "MX-MEX-021",
    "name": "Chapa de Mota"
  },
  {
    "code": "MX-YUC-015",
    "name": "Chapab"
  },
  {
    "code": "MX-JAL-020",
    "name": "Chapala"
  },
  {
    "code": "MX-HID-015",
    "name": "Chapantongo"
  },
  {
    "code": "MX-PUE-033",
    "name": "Chapulco"
  },
  {
    "code": "MX-HID-016",
    "name": "Chapulhuacán"
  },
  {
    "code": "MX-CHP-021",
    "name": "Chapultenango"
  },
  {
    "code": "MX-MEX-022",
    "name": "Chapultepec"
  },
  {
    "code": "MX-MIC-013",
    "name": "Charapan"
  },
  {
    "code": "MX-SLP-010",
    "name": "Charcas"
  },
  {
    "code": "MX-MIC-014",
    "name": "Charo"
  },
  {
    "code": "MX-MIC-015",
    "name": "Chavinda"
  },
  {
    "code": "MX-YUC-016",
    "name": "Chemax"
  },
  {
    "code": "MX-CHP-022",
    "name": "Chenalhó"
  },
  {
    "code": "MX-MIC-016",
    "name": "Cherán"
  },
  {
    "code": "MX-CHP-023",
    "name": "Chiapa de Corzo"
  },
  {
    "code": "MX-CHP-024",
    "name": "Chiapilla"
  },
  {
    "code": "MX-TLA-009",
    "name": "Chiautempan"
  },
  {
    "code": "MX-MEX-023",
    "name": "Chiautla"
  },
  {
    "code": "MX-PUE-034",
    "name": "Chiautla"
  },
  {
    "code": "MX-PUE-035",
    "name": "Chiautzingo"
  },
  {
    "code": "MX-YUC-017",
    "name": "Chichimilá"
  },
  {
    "code": "MX-PUE-036",
    "name": "Chichiquila"
  },
  {
    "code": "MX-CHP-025",
    "name": "Chicoasén"
  },
  {
    "code": "MX-MEX-024",
    "name": "Chicoloapan"
  },
  {
    "code": "MX-CHP-026",
    "name": "Chicomuselo"
  },
  {
    "code": "MX-VER-037",
    "name": "Chiconamel"
  },
  {
    "code": "MX-MEX-025",
    "name": "Chiconcuac"
  },
  {
    "code": "MX-PUE-037",
    "name": "Chiconcuautla"
  },
  {
    "code": "MX-VER-038",
    "name": "Chiconquiaco"
  },
  {
    "code": "MX-VER-039",
    "name": "Chicontepec"
  },
  {
    "code": "MX-YUC-018",
    "name": "Chicxulub Pueblo"
  },
  {
    "code": "MX-PUE-038",
    "name": "Chietla"
  },
  {
    "code": "MX-PUE-039",
    "name": "Chigmecatitlán"
  },
  {
    "code": "MX-PUE-040",
    "name": "Chignahuapan"
  },
  {
    "code": "MX-PUE-041",
    "name": "Chignautla"
  },
  {
    "code": "MX-CHH-014",
    "name": "Chihuahua"
  },
  {
    "code": "MX-YUC-019",
    "name": "Chikindzonot"
  },
  {
    "code": "MX-PUE-042",
    "name": "Chila"
  },
  {
    "code": "MX-PUE-043",
    "name": "Chila de la Sal"
  },
  {
    "code": "MX-GRO-017",
    "name": "Chilapa de Álvarez"
  },
  {
    "code": "MX-MIC-017",
    "name": "Chilchota"
  },
  {
    "code": "MX-PUE-044",
    "name": "Chilchotla"
  },
  {
    "code": "MX-HID-017",
    "name": "Chilcuautla"
  },
  {
    "code": "MX-GRO-018",
    "name": "Chilpancingo de los Bravo"
  },
  {
    "code": "MX-CHP-027",
    "name": "Chilón"
  },
  {
    "code": "MX-MEX-026",
    "name": "Chimalhuacán"
  },
  {
    "code": "MX-JAL-021",
    "name": "Chimaltitán"
  },
  {
    "code": "MX-NLE-011",
    "name": "China"
  },
  {
    "code": "MX-VER-040",
    "name": "Chinameca"
  },
  {
    "code": "MX-VER-041",
    "name": "Chinampa de Gorostiza"
  },
  {
    "code": "MX-PUE-045",
    "name": "Chinantla"
  },
  {
    "code": "MX-MIC-018",
    "name": "Chinicuila"
  },
  {
    "code": "MX-JAL-022",
    "name": "Chiquilistlán"
  },
  {
    "code": "MX-OAX-002",
    "name": "Choapam"
  },
  {
    "code": "MX-VER-042",
    "name": "Chocamán"
  },
  {
    "code": "MX-YUC-020",
    "name": "Chocholá"
  },
  {
    "code": "MX-SIN-004",
    "name": "Choix"
  },
  {
    "code": "MX-VER-043",
    "name": "Chontla"
  },
  {
    "code": "MX-MIC-019",
    "name": "Chucándiro"
  },
  {
    "code": "MX-VER-044",
    "name": "Chumatlán"
  },
  {
    "code": "MX-YUC-021",
    "name": "Chumayel"
  },
  {
    "code": "MX-MIC-020",
    "name": "Churintzio"
  },
  {
    "code": "MX-MIC-021",
    "name": "Churumuco"
  },
  {
    "code": "MX-CHH-015",
    "name": "Chínipas"
  },
  {
    "code": "MX-JAL-023",
    "name": "Cihuatlán"
  },
  {
    "code": "MX-CHP-028",
    "name": "Cintalapa"
  },
  {
    "code": "MX-VER-045",
    "name": "Citlaltépetl"
  },
  {
    "code": "MX-SLP-013",
    "name": "Ciudad del Maíz"
  },
  {
    "code": "MX-SLP-011",
    "name": "Ciudad Fernández"
  },
  {
    "code": "MX-TAM-009",
    "name": "Ciudad Madero"
  },
  {
    "code": "MX-SLP-012",
    "name": "Ciudad Valles"
  },
  {
    "code": "MX-NLE-012",
    "name": "Ciénega de Flores"
  },
  {
    "code": "MX-MEX-027",
    "name": "Coacalco de Berriozábal"
  },
  {
    "code": "MX-VER-046",
    "name": "Coacoatzintla"
  },
  {
    "code": "MX-MIC-022",
    "name": "Coahuayana"
  },
  {
    "code": "MX-GRO-019",
    "name": "Coahuayutla de José María Izazaga"
  },
  {
    "code": "MX-VER-047",
    "name": "Coahuitlán"
  },
  {
    "code": "MX-MIC-023",
    "name": "Coalcomán de Vázquez Pallares"
  },
  {
    "code": "MX-CHP-029",
    "name": "Coapilla"
  },
  {
    "code": "MX-VER-048",
    "name": "Coatepec"
  },
  {
    "code": "MX-PUE-046",
    "name": "Coatepec"
  },
  {
    "code": "MX-MEX-028",
    "name": "Coatepec Harinas"
  },
  {
    "code": "MX-MOR-005",
    "name": "Coatlán del Río"
  },
  {
    "code": "MX-VER-049",
    "name": "Coatzacoalcos"
  },
  {
    "code": "MX-PUE-047",
    "name": "Coatzingo"
  },
  {
    "code": "MX-VER-050",
    "name": "Coatzintla"
  },
  {
    "code": "MX-GRO-020",
    "name": "Cochoapa el Grande"
  },
  {
    "code": "MX-MEX-029",
    "name": "Cocotitlán"
  },
  {
    "code": "MX-GRO-021",
    "name": "Cocula"
  },
  {
    "code": "MX-JAL-024",
    "name": "Cocula"
  },
  {
    "code": "MX-MIC-024",
    "name": "Coeneo"
  },
  {
    "code": "MX-VER-051",
    "name": "Coetzala"
  },
  {
    "code": "MX-PUE-048",
    "name": "Cohetzala"
  },
  {
    "code": "MX-PUE-049",
    "name": "Cohuecan"
  },
  {
    "code": "MX-OAX-003",
    "name": "Coixtlahuaca"
  },
  {
    "code": "MX-MIC-025",
    "name": "Cojumatlán de Régules"
  },
  {
    "code": "MX-COL-002",
    "name": "Colima"
  },
  {
    "code": "MX-VER-052",
    "name": "Colipa"
  },
  {
    "code": "MX-JAL-025",
    "name": "Colotlán"
  },
  {
    "code": "MX-QUE-004",
    "name": "Colón"
  },
  {
    "code": "MX-COL-003",
    "name": "Comala"
  },
  {
    "code": "MX-TAB-004",
    "name": "Comalcalco"
  },
  {
    "code": "MX-VER-053",
    "name": "Comapa"
  },
  {
    "code": "MX-CHP-030",
    "name": "Comitán"
  },
  {
    "code": "MX-BCS-001",
    "name": "Comondú"
  },
  {
    "code": "MX-GUA-007",
    "name": "Comonfort"
  },
  {
    "code": "MX-NAY-005",
    "name": "Compostela"
  },
  {
    "code": "MX-JAL-026",
    "name": "Concepción de Buenos Aires"
  },
  {
    "code": "MX-ZAC-008",
    "name": "Concepción del Oro"
  },
  {
    "code": "MX-SIN-005",
    "name": "Concordia"
  },
  {
    "code": "MX-DUR-003",
    "name": "Coneto de Comonfort"
  },
  {
    "code": "MX-YUC-022",
    "name": "Conkal"
  },
  {
    "code": "MX-MIC-026",
    "name": "Contepec"
  },
  {
    "code": "MX-TLA-010",
    "name": "Contla de Juan Cuamatzi"
  },
  {
    "code": "MX-CHP-031",
    "name": "Copainalá"
  },
  {
    "code": "MX-GRO-022",
    "name": "Copala"
  },
  {
    "code": "MX-GRO-023",
    "name": "Copalillo"
  },
  {
    "code": "MX-GRO-024",
    "name": "Copanatoyac"
  },
  {
    "code": "MX-MIC-027",
    "name": "Copándaro"
  },
  {
    "code": "MX-COL-004",
    "name": "Coquimatlán"
  },
  {
    "code": "MX-CHH-016",
    "name": "Coronado"
  },
  {
    "code": "MX-PUE-050",
    "name": "Coronango"
  },
  {
    "code": "MX-GUA-008",
    "name": "Coroneo"
  },
  {
    "code": "MX-QUE-005",
    "name": "Corregidora"
  },
  {
    "code": "MX-GUA-009",
    "name": "Cortazar"
  },
  {
    "code": "MX-SIN-006",
    "name": "Cosalá"
  },
  {
    "code": "MX-VER-054",
    "name": "Cosamaloapan de Carpio"
  },
  {
    "code": "MX-VER-055",
    "name": "Cosautlán de Carvajal"
  },
  {
    "code": "MX-VER-056",
    "name": "Coscomatepec"
  },
  {
    "code": "MX-VER-057",
    "name": "Cosoleacaque"
  },
  {
    "code": "MX-AGU-004",
    "name": "Cosío"
  },
  {
    "code": "MX-VER-058",
    "name": "Cotaxtla"
  },
  {
    "code": "MX-MIC-028",
    "name": "Cotija"
  },
  {
    "code": "MX-PUE-051",
    "name": "Coxcatlán"
  },
  {
    "code": "MX-SLP-014",
    "name": "Coxcatlán"
  },
  {
    "code": "MX-VER-059",
    "name": "Coxquihui"
  },
  {
    "code": "MX-CHH-017",
    "name": "Coyame del Sotol"
  },
  {
    "code": "MX-DIF-003",
    "name": "Coyoacán"
  },
  {
    "code": "MX-PUE-052",
    "name": "Coyomeapan"
  },
  {
    "code": "MX-MEX-030",
    "name": "Coyotepec"
  },
  {
    "code": "MX-PUE-053",
    "name": "Coyotepec"
  },
  {
    "code": "MX-GRO-025",
    "name": "Coyuca de Benítez"
  },
  {
    "code": "MX-GRO-026",
    "name": "Coyuca de Catalán"
  },
  {
    "code": "MX-VER-060",
    "name": "Coyutla"
  },
  {
    "code": "MX-ROO-002",
    "name": "Cozumel"
  },
  {
    "code": "MX-TAM-010",
    "name": "Cruillas"
  },
  {
    "code": "MX-DIF-004",
    "name": "Cuajimalpa de Morelos"
  },
  {
    "code": "MX-GRO-027",
    "name": "Cuajinicuilapa"
  },
  {
    "code": "MX-GRO-028",
    "name": "Cualác"
  },
  {
    "code": "MX-TLA-011",
    "name": "Cuapiaxtla"
  },
  {
    "code": "MX-PUE-054",
    "name": "Cuapiaxtla de Madero"
  },
  {
    "code": "MX-COA-007",
    "name": "Cuatro Ciénegas"
  },
  {
    "code": "MX-CHH-018",
    "name": "Cuauhtémoc"
  },
  {
    "code": "MX-DIF-005",
    "name": "Cuauhtémoc"
  },
  {
    "code": "MX-COL-005",
    "name": "Cuauhtémoc"
  },
  {
    "code": "MX-ZAC-009",
    "name": "Cuauhtémoc"
  },
  {
    "code": "MX-PUE-055",
    "name": "Cuautempan"
  },
  {
    "code": "MX-GRO-029",
    "name": "Cuautepec"
  },
  {
    "code": "MX-HID-018",
    "name": "Cuautepec de Hinojosa"
  },
  {
    "code": "MX-PUE-056",
    "name": "Cuautinchán"
  },
  {
    "code": "MX-MEX-031",
    "name": "Cuautitlán"
  },
  {
    "code": "MX-JAL-027",
    "name": "Cuautitlán de García Barragán"
  },
  {
    "code": "MX-MEX-032",
    "name": "Cuautitlán Izcalli"
  },
  {
    "code": "MX-MOR-006",
    "name": "Cuautla"
  },
  {
    "code": "MX-JAL-028",
    "name": "Cuautla"
  },
  {
    "code": "MX-PUE-057",
    "name": "Cuautlancingo"
  },
  {
    "code": "MX-TLA-012",
    "name": "Cuaxomulco"
  },
  {
    "code": "MX-PUE-058",
    "name": "Cuayuca de Andrade"
  },
  {
    "code": "MX-SON-022",
    "name": "Cucurpe"
  },
  {
    "code": "MX-DUR-004",
    "name": "Cuencamé"
  },
  {
    "code": "MX-MOR-007",
    "name": "Cuernavaca"
  },
  {
    "code": "MX-GUA-010",
    "name": "Cuerámaro"
  },
  {
    "code": "MX-GRO-030",
    "name": "Cuetzala del Progreso"
  },
  {
    "code": "MX-PUE-059",
    "name": "Cuetzalan"
  },
  {
    "code": "MX-OAX-004",
    "name": "Cuicatlán"
  },
  {
    "code": "MX-VER-061",
    "name": "Cuichapa"
  },
  {
    "code": "MX-VER-062",
    "name": "Cuitláhuac"
  },
  {
    "code": "MX-MIC-029",
    "name": "Cuitzeo"
  },
  {
    "code": "MX-SIN-007",
    "name": "Culiacán"
  },
  {
    "code": "MX-SON-023",
    "name": "Cumpas"
  },
  {
    "code": "MX-YUC-023",
    "name": "Cuncunul"
  },
  {
    "code": "MX-TAB-005",
    "name": "Cunduacán"
  },
  {
    "code": "MX-JAL-029",
    "name": "Cuquío"
  },
  {
    "code": "MX-CHH-019",
    "name": "Cusihuiriachi"
  },
  {
    "code": "MX-GRO-031",
    "name": "Cutzamala de Pinzón"
  },
  {
    "code": "MX-PUE-060",
    "name": "Cuyoaco"
  },
  {
    "code": "MX-YUC-024",
    "name": "Cuzamá"
  },
  {
    "code": "MX-TAB-006",
    "name": "Cárdenas"
  },
  {
    "code": "MX-SLP-015",
    "name": "Cárdenas"
  },
  {
    "code": "MX-VER-063",
    "name": "Córdoba"
  },
  {
    "code": "MX-JAL-030",
    "name": "Degollado"
  },
  {
    "code": "MX-CHH-020",
    "name": "Delicias"
  },
  {
    "code": "MX-SON-024",
    "name": "Divisaderos"
  },
  {
    "code": "MX-NLE-013",
    "name": "Doctor Arroyo"
  },
  {
    "code": "MX-CHH-021",
    "name": "Doctor Belisario Domínguez"
  },
  {
    "code": "MX-NLE-014",
    "name": "Doctor Coss"
  },
  {
    "code": "MX-NLE-015",
    "name": "Doctor González"
  },
  {
    "code": "MX-GUA-011",
    "name": "Doctor Mora"
  },
  {
    "code": "MX-GUA-012",
    "name": "Dolores Hidalgo"
  },
  {
    "code": "MX-PUE-061",
    "name": "Domingo Arenas"
  },
  {
    "code": "MX-MEX-033",
    "name": "Donato Guerra"
  },
  {
    "code": "MX-DUR-005",
    "name": "Durango"
  },
  {
    "code": "MX-YUC-025",
    "name": "Dzemul"
  },
  {
    "code": "MX-YUC-026",
    "name": "Dzidzantún"
  },
  {
    "code": "MX-YUC-028",
    "name": "Dzilam de Bravo"
  },
  {
    "code": "MX-YUC-027",
    "name": "Dzilam González"
  },
  {
    "code": "MX-YUC-029",
    "name": "Dzitás"
  },
  {
    "code": "MX-YUC-030",
    "name": "Dzoncauich"
  },
  {
    "code": "MX-YUC-031",
    "name": "Dzán"
  },
  {
    "code": "MX-SLP-016",
    "name": "Ebano"
  },
  {
    "code": "MX-MEX-034",
    "name": "Ecatepec"
  },
  {
    "code": "MX-MEX-035",
    "name": "Ecatzingo"
  },
  {
    "code": "MX-MIC-030",
    "name": "Ecuandureo"
  },
  {
    "code": "MX-GRO-032",
    "name": "Eduardo Neri"
  },
  {
    "code": "MX-OAX-005",
    "name": "Ejutla"
  },
  {
    "code": "MX-JAL-031",
    "name": "Ejutla"
  },
  {
    "code": "MX-HID-019",
    "name": "El Arenal"
  },
  {
    "code": "MX-JAL-032",
    "name": "El Arenal"
  },
  {
    "code": "MX-CHP-032",
    "name": "El Bosque"
  },
  {
    "code": "MX-TLA-013",
    "name": "El Carmen Tequexquitla"
  },
  {
    "code": "MX-SIN-008",
    "name": "El Fuerte"
  },
  {
    "code": "MX-JAL-033",
    "name": "El Grullo"
  },
  {
    "code": "MX-VER-064",
    "name": "El Higo"
  },
  {
    "code": "MX-JAL-034",
    "name": "El Limón"
  },
  {
    "code": "MX-AGU-005",
    "name": "El Llano"
  },
  {
    "code": "MX-TAM-011",
    "name": "El Mante"
  },
  {
    "code": "MX-QUE-006",
    "name": "El Marqués"
  },
  {
    "code": "MX-SLP-017",
    "name": "El Naranjo"
  },
  {
    "code": "MX-NAY-006",
    "name": "El Nayar"
  },
  {
    "code": "MX-MEX-036",
    "name": "El Oro"
  },
  {
    "code": "MX-DUR-006",
    "name": "El Oro"
  },
  {
    "code": "MX-ZAC-010",
    "name": "El Plateado de Joaquín Amaro"
  },
  {
    "code": "MX-CHP-033",
    "name": "El Porvenir"
  },
  {
    "code": "MX-JAL-035",
    "name": "El Salto"
  },
  {
    "code": "MX-ZAC-011",
    "name": "El Salvador"
  },
  {
    "code": "MX-CHH-022",
    "name": "El Tule"
  },
  {
    "code": "MX-SIN-009",
    "name": "Elota"
  },
  {
    "code": "MX-PUE-062",
    "name": "Eloxochitlán"
  },
  {
    "code": "MX-HID-020",
    "name": "Eloxochitlán"
  },
  {
    "code": "MX-VER-065",
    "name": "Emiliano Zapata"
  },
  {
    "code": "MX-TAB-007",
    "name": "Emiliano Zapata"
  },
  {
    "code": "MX-MOR-008",
    "name": "Emiliano Zapata"
  },
  {
    "code": "MX-HID-021",
    "name": "Emiliano Zapata"
  },
  {
    "code": "MX-TLA-014",
    "name": "Emiliano Zapata"
  },
  {
    "code": "MX-SON-025",
    "name": "Empalme"
  },
  {
    "code": "MX-JAL-036",
    "name": "Encarnación de Díaz"
  },
  {
    "code": "MX-BCN-001",
    "name": "Ensenada"
  },
  {
    "code": "MX-PUE-063",
    "name": "Epatlán"
  },
  {
    "code": "MX-HID-022",
    "name": "Epazoyucan"
  },
  {
    "code": "MX-MIC-031",
    "name": "Epitacio Huerta"
  },
  {
    "code": "MX-MIC-032",
    "name": "Erongarícuaro"
  },
  {
    "code": "MX-COA-008",
    "name": "Escobedo"
  },
  {
    "code": "MX-SIN-010",
    "name": "Escuinapa"
  },
  {
    "code": "MX-CHP-034",
    "name": "Escuintla"
  },
  {
    "code": "MX-CAM-007",
    "name": "Escárcega"
  },
  {
    "code": "MX-TLA-015",
    "name": "Españita"
  },
  {
    "code": "MX-PUE-064",
    "name": "Esperanza"
  },
  {
    "code": "MX-VER-066",
    "name": "Espinal"
  },
  {
    "code": "MX-YUC-032",
    "name": "Espita"
  },
  {
    "code": "MX-SON-026",
    "name": "Etchojoa"
  },
  {
    "code": "MX-OAX-006",
    "name": "Etla"
  },
  {
    "code": "MX-JAL-037",
    "name": "Etzatlán"
  },
  {
    "code": "MX-QUE-007",
    "name": "Ezequiel Montes"
  },
  {
    "code": "MX-ROO-003",
    "name": "Felipe Carrillo Puerto"
  },
  {
    "code": "MX-VER-067",
    "name": "Filomeno Mata"
  },
  {
    "code": "MX-GRO-033",
    "name": "Florencio Villarreal"
  },
  {
    "code": "MX-VER-068",
    "name": "Fortín"
  },
  {
    "code": "MX-COA-009",
    "name": "Francisco I. Madero"
  },
  {
    "code": "MX-HID-023",
    "name": "Francisco I. Madero"
  },
  {
    "code": "MX-CHP-035",
    "name": "Francisco León"
  },
  {
    "code": "MX-PUE-065",
    "name": "Francisco Z. Mena"
  },
  {
    "code": "MX-ZAC-012",
    "name": "Fresnillo"
  },
  {
    "code": "MX-COA-010",
    "name": "Frontera"
  },
  {
    "code": "MX-CHP-036",
    "name": "Frontera Comalapa"
  },
  {
    "code": "MX-CHP-037",
    "name": "Frontera Hidalgo"
  },
  {
    "code": "MX-SON-027",
    "name": "Fronteras"
  },
  {
    "code": "MX-MIC-033",
    "name": "Gabriel Zamora"
  },
  {
    "code": "MX-NLE-016",
    "name": "Galeana"
  },
  {
    "code": "MX-CHH-023",
    "name": "Galeana"
  },
  {
    "code": "MX-NLE-017",
    "name": "García"
  },
  {
    "code": "MX-ZAC-013",
    "name": "Genaro Codina"
  },
  {
    "code": "MX-NLE-018",
    "name": "General Bravo"
  },
  {
    "code": "MX-GRO-034",
    "name": "General Canuto A. Neri"
  },
  {
    "code": "MX-COA-011",
    "name": "General Cepeda"
  },
  {
    "code": "MX-ZAC-014",
    "name": "General Enrique Estrada"
  },
  {
    "code": "MX-NLE-019",
    "name": "General Escobedo"
  },
  {
    "code": "MX-PUE-066",
    "name": "General Felipe Ángeles"
  },
  {
    "code": "MX-ZAC-015",
    "name": "General Francisco R. Murguía"
  },
  {
    "code": "MX-GRO-035",
    "name": "General Heliodoro Castillo"
  },
  {
    "code": "MX-SON-028",
    "name": "General Plutarco Elías Calles"
  },
  {
    "code": "MX-ZAC-016",
    "name": "General Pánfilo Natera"
  },
  {
    "code": "MX-DUR-007",
    "name": "General Simón Bolívar"
  },
  {
    "code": "MX-NLE-020",
    "name": "General Terán"
  },
  {
    "code": "MX-NLE-021",
    "name": "General Treviño"
  },
  {
    "code": "MX-NLE-022",
    "name": "General Zaragoza"
  },
  {
    "code": "MX-NLE-023",
    "name": "General Zuazua"
  },
  {
    "code": "MX-TAM-012",
    "name": "González"
  },
  {
    "code": "MX-CHH-024",
    "name": "Gran Morelos"
  },
  {
    "code": "MX-SON-029",
    "name": "Granados"
  },
  {
    "code": "MX-JAL-038",
    "name": "Guachinango"
  },
  {
    "code": "MX-CHH-025",
    "name": "Guachochi"
  },
  {
    "code": "MX-JAL-039",
    "name": "Guadalajara"
  },
  {
    "code": "MX-SLP-018",
    "name": "Guadalcázar"
  },
  {
    "code": "MX-ZAC-017",
    "name": "Guadalupe"
  },
  {
    "code": "MX-NLE-024",
    "name": "Guadalupe"
  },
  {
    "code": "MX-CHH-026",
    "name": "Guadalupe"
  },
  {
    "code": "MX-PUE-067",
    "name": "Guadalupe"
  },
  {
    "code": "MX-DUR-008",
    "name": "Guadalupe Victoria"
  },
  {
    "code": "MX-PUE-068",
    "name": "Guadalupe Victoria"
  },
  {
    "code": "MX-CHH-027",
    "name": "Guadalupe y Calvo"
  },
  {
    "code": "MX-DUR-009",
    "name": "Guanaceví"
  },
  {
    "code": "MX-GUA-013",
    "name": "Guanajuato"
  },
  {
    "code": "MX-SIN-011",
    "name": "Guasave"
  },
  {
    "code": "MX-SON-030",
    "name": "Guaymas"
  },
  {
    "code": "MX-CHH-028",
    "name": "Guazapares"
  },
  {
    "code": "MX-COA-012",
    "name": "Guerrero"
  },
  {
    "code": "MX-TAM-013",
    "name": "Guerrero"
  },
  {
    "code": "MX-CHH-029",
    "name": "Guerrero"
  },
  {
    "code": "MX-DIF-006",
    "name": "Gustavo A. Madero"
  },
  {
    "code": "MX-TAM-014",
    "name": "Gustavo Díaz Ordaz"
  },
  {
    "code": "MX-VER-069",
    "name": "Gutiérrez Zamora"
  },
  {
    "code": "MX-TAM-015",
    "name": "Gómez Farías"
  },
  {
    "code": "MX-CHH-030",
    "name": "Gómez Farías"
  },
  {
    "code": "MX-JAL-040",
    "name": "Gómez Farías"
  },
  {
    "code": "MX-DUR-010",
    "name": "Gómez Palacio"
  },
  {
    "code": "MX-TAM-016",
    "name": "Güémez"
  },
  {
    "code": "MX-YUC-033",
    "name": "Halachó"
  },
  {
    "code": "MX-CAM-008",
    "name": "Hecelchakán"
  },
  {
    "code": "MX-PUE-069",
    "name": "Hermenegildo Galeana"
  },
  {
    "code": "MX-SON-031",
    "name": "Hermosillo"
  },
  {
    "code": "MX-MIC-034",
    "name": "Hidalgo"
  },
  {
    "code": "MX-NLE-025",
    "name": "Hidalgo"
  },
  {
    "code": "MX-DUR-011",
    "name": "Hidalgo"
  },
  {
    "code": "MX-COA-013",
    "name": "Hidalgo"
  },
  {
    "code": "MX-TAM-017",
    "name": "Hidalgo"
  },
  {
    "code": "MX-CHH-031",
    "name": "Hidalgo del Parral"
  },
  {
    "code": "MX-VER-070",
    "name": "Hidalgotitlán"
  },
  {
    "code": "MX-NLE-026",
    "name": "Higueras"
  },
  {
    "code": "MX-YUC-034",
    "name": "Hocabá"
  },
  {
    "code": "MX-YUC-035",
    "name": "Hoctún"
  },
  {
    "code": "MX-YUC-036",
    "name": "Homún"
  },
  {
    "code": "MX-PUE-070",
    "name": "Honey"
  },
  {
    "code": "MX-CAM-009",
    "name": "Hopelchén"
  },
  {
    "code": "MX-JAL-041",
    "name": "Hostotipaquillo"
  },
  {
    "code": "MX-SON-032",
    "name": "Huachinera"
  },
  {
    "code": "MX-NAY-007",
    "name": "Huajicori"
  },
  {
    "code": "MX-OAX-007",
    "name": "Huajuapan"
  },
  {
    "code": "MX-NLE-027",
    "name": "Hualahuises"
  },
  {
    "code": "MX-TLA-016",
    "name": "Huamantla"
  },
  {
    "code": "MX-GRO-036",
    "name": "Huamuxtitlán"
  },
  {
    "code": "MX-MIC-035",
    "name": "Huandacareo"
  },
  {
    "code": "MX-MIC-036",
    "name": "Huaniqueo"
  },
  {
    "code": "MX-ZAC-018",
    "name": "Huanusco"
  },
  {
    "code": "MX-GUA-014",
    "name": "Huanímaro"
  },
  {
    "code": "MX-PUE-071",
    "name": "Huaquechula"
  },
  {
    "code": "MX-HID-024",
    "name": "Huasca de Ocampo"
  },
  {
    "code": "MX-SON-033",
    "name": "Huatabampo"
  },
  {
    "code": "MX-PUE-072",
    "name": "Huatlatlauca"
  },
  {
    "code": "MX-VER-071",
    "name": "Huatusco"
  },
  {
    "code": "MX-PUE-073",
    "name": "Huauchinango"
  },
  {
    "code": "MX-HID-025",
    "name": "Huautla"
  },
  {
    "code": "MX-VER-072",
    "name": "Huayacocotla"
  },
  {
    "code": "MX-HID-026",
    "name": "Huazalingo"
  },
  {
    "code": "MX-PUE-074",
    "name": "Huehuetla"
  },
  {
    "code": "MX-HID-027",
    "name": "Huehuetla"
  },
  {
    "code": "MX-SLP-019",
    "name": "Huehuetlán"
  },
  {
    "code": "MX-PUE-075",
    "name": "Huehuetlán el Chico"
  },
  {
    "code": "MX-PUE-076",
    "name": "Huehuetlán el Grande"
  },
  {
    "code": "MX-MEX-037",
    "name": "Huehuetoca"
  },
  {
    "code": "MX-CHP-038",
    "name": "Huehuetán"
  },
  {
    "code": "MX-CHH-032",
    "name": "Huejotitán"
  },
  {
    "code": "MX-PUE-077",
    "name": "Huejotzingo"
  },
  {
    "code": "MX-JAL-042",
    "name": "Huejuquilla el Alto"
  },
  {
    "code": "MX-HID-028",
    "name": "Huejutla de Reyes"
  },
  {
    "code": "MX-JAL-043",
    "name": "Huejúcar"
  },
  {
    "code": "MX-MIC-037",
    "name": "Huetamo"
  },
  {
    "code": "MX-PUE-078",
    "name": "Hueyapan"
  },
  {
    "code": "MX-VER-073",
    "name": "Hueyapan de Ocampo"
  },
  {
    "code": "MX-TLA-017",
    "name": "Hueyotlipan"
  },
  {
    "code": "MX-MEX-038",
    "name": "Hueypoxtla"
  },
  {
    "code": "MX-PUE-079",
    "name": "Hueytamalco"
  },
  {
    "code": "MX-PUE-080",
    "name": "Hueytlalpan"
  },
  {
    "code": "MX-YUC-037",
    "name": "Huhí"
  },
  {
    "code": "MX-HID-029",
    "name": "Huichapan"
  },
  {
    "code": "MX-VER-074",
    "name": "Huiloapan de Cuauhtémoc"
  },
  {
    "code": "MX-TAB-008",
    "name": "Huimanguillo"
  },
  {
    "code": "MX-QUE-008",
    "name": "Huimilpan"
  },
  {
    "code": "MX-MIC-038",
    "name": "Huiramba"
  },
  {
    "code": "MX-CHP-039",
    "name": "Huitiupán"
  },
  {
    "code": "MX-MOR-009",
    "name": "Huitzilac"
  },
  {
    "code": "MX-PUE-081",
    "name": "Huitzilan de Serdán"
  },
  {
    "code": "MX-PUE-082",
    "name": "Huitziltepec"
  },
  {
    "code": "MX-GRO-037",
    "name": "Huitzuco de los Figueroa"
  },
  {
    "code": "MX-MEX-039",
    "name": "Huixquilucan"
  },
  {
    "code": "MX-CHP-040",
    "name": "Huixtla"
  },
  {
    "code": "MX-CHP-041",
    "name": "Huixtán"
  },
  {
    "code": "MX-YUC-038",
    "name": "Hunucmá"
  },
  {
    "code": "MX-SON-034",
    "name": "Huásabas"
  },
  {
    "code": "MX-SON-035",
    "name": "Huépac"
  },
  {
    "code": "MX-VER-075",
    "name": "Ignacio de la Llave"
  },
  {
    "code": "MX-CHH-033",
    "name": "Ignacio Zaragoza"
  },
  {
    "code": "MX-GRO-038",
    "name": "Iguala de la Independencia"
  },
  {
    "code": "MX-GRO-039",
    "name": "Igualapa"
  },
  {
    "code": "MX-VER-076",
    "name": "Ilamatlán"
  },
  {
    "code": "MX-GRO-040",
    "name": "Iliatenco"
  },
  {
    "code": "MX-SON-036",
    "name": "Imuris"
  },
  {
    "code": "MX-MIC-039",
    "name": "Indaparapeo"
  },
  {
    "code": "MX-DUR-012",
    "name": "Indé"
  },
  {
    "code": "MX-GUA-015",
    "name": "Irapuato"
  },
  {
    "code": "MX-MIC-040",
    "name": "Irimbo"
  },
  {
    "code": "MX-MEX-040",
    "name": "Isidro Fabela"
  },
  {
    "code": "MX-VER-077",
    "name": "Isla"
  },
  {
    "code": "MX-ROO-004",
    "name": "Isla Mujeres"
  },
  {
    "code": "MX-NLE-028",
    "name": "Iturbide"
  },
  {
    "code": "MX-PUE-083",
    "name": "Ixcamilpa de Guerrero"
  },
  {
    "code": "MX-PUE-084",
    "name": "Ixcaquixtla"
  },
  {
    "code": "MX-GRO-041",
    "name": "Ixcateopan de Cuauhtémoc"
  },
  {
    "code": "MX-VER-078",
    "name": "Ixcatepec"
  },
  {
    "code": "MX-VER-079",
    "name": "Ixhuacán"
  },
  {
    "code": "MX-VER-080",
    "name": "Ixhuatlancillo"
  },
  {
    "code": "MX-VER-081",
    "name": "Ixhuatlán de Madero"
  },
  {
    "code": "MX-VER-082",
    "name": "Ixhuatlán del Café"
  },
  {
    "code": "MX-VER-083",
    "name": "Ixhuatlán del Sureste"
  },
  {
    "code": "MX-CHP-042",
    "name": "Ixhuatán"
  },
  {
    "code": "MX-YUC-039",
    "name": "Ixil"
  },
  {
    "code": "MX-VER-084",
    "name": "Ixmatlahuacan"
  },
  {
    "code": "MX-HID-030",
    "name": "Ixmiquilpan"
  },
  {
    "code": "MX-PUE-085",
    "name": "Ixtacamaxtitlán"
  },
  {
    "code": "MX-CHP-043",
    "name": "Ixtacomitán"
  },
  {
    "code": "MX-TLA-018",
    "name": "Ixtacuixtla de Mariano Matamoros"
  },
  {
    "code": "MX-VER-085",
    "name": "Ixtaczoquitlán"
  },
  {
    "code": "MX-CHP-044",
    "name": "Ixtapa"
  },
  {
    "code": "MX-MEX-041",
    "name": "Ixtapaluca"
  },
  {
    "code": "MX-MEX-042",
    "name": "Ixtapan de la Sal"
  },
  {
    "code": "MX-MEX-043",
    "name": "Ixtapan del Oro"
  },
  {
    "code": "MX-CHP-045",
    "name": "Ixtapangajoya"
  },
  {
    "code": "MX-TLA-019",
    "name": "Ixtenco"
  },
  {
    "code": "MX-PUE-086",
    "name": "Ixtepec"
  },
  {
    "code": "MX-MEX-044",
    "name": "Ixtlahuaca"
  },
  {
    "code": "MX-COL-006",
    "name": "Ixtlahuacán"
  },
  {
    "code": "MX-JAL-044",
    "name": "Ixtlahuacán de los Membrillos"
  },
  {
    "code": "MX-JAL-045",
    "name": "Ixtlahuacán del Río"
  },
  {
    "code": "MX-MIC-041",
    "name": "Ixtlán"
  },
  {
    "code": "MX-OAX-008",
    "name": "Ixtlán"
  },
  {
    "code": "MX-NAY-008",
    "name": "Ixtlán del Río"
  },
  {
    "code": "MX-YUC-040",
    "name": "Izamal"
  },
  {
    "code": "MX-DIF-007",
    "name": "Iztacalco"
  },
  {
    "code": "MX-DIF-008",
    "name": "Iztapalapa"
  },
  {
    "code": "MX-PUE-087",
    "name": "Izúcar de Matamoros"
  },
  {
    "code": "MX-HID-031",
    "name": "Jacala"
  },
  {
    "code": "MX-MIC-042",
    "name": "Jacona"
  },
  {
    "code": "MX-NAY-009",
    "name": "Jala"
  },
  {
    "code": "MX-VER-086",
    "name": "Jalacingo"
  },
  {
    "code": "MX-TAB-009",
    "name": "Jalapa"
  },
  {
    "code": "MX-VER-087",
    "name": "Jalcomulco"
  },
  {
    "code": "MX-JAL-046",
    "name": "Jalostotitlán"
  },
  {
    "code": "MX-ZAC-019",
    "name": "Jalpa"
  },
  {
    "code": "MX-TAB-010",
    "name": "Jalpa de Méndez"
  },
  {
    "code": "MX-PUE-088",
    "name": "Jalpan"
  },
  {
    "code": "MX-QUE-009",
    "name": "Jalpan de Serra"
  },
  {
    "code": "MX-MEX-045",
    "name": "Jaltenco"
  },
  {
    "code": "MX-HID-032",
    "name": "Jaltocán"
  },
  {
    "code": "MX-VER-088",
    "name": "Jamapa"
  },
  {
    "code": "MX-JAL-047",
    "name": "Jamay"
  },
  {
    "code": "MX-OAX-009",
    "name": "Jamiltepec"
  },
  {
    "code": "MX-CHH-034",
    "name": "Janos"
  },
  {
    "code": "MX-MOR-010",
    "name": "Jantetelco"
  },
  {
    "code": "MX-GUA-016",
    "name": "Jaral del Progreso"
  },
  {
    "code": "MX-TAM-018",
    "name": "Jaumave"
  },
  {
    "code": "MX-ZAC-020",
    "name": "Jerez"
  },
  {
    "code": "MX-GUA-017",
    "name": "Jerécuaro"
  },
  {
    "code": "MX-VER-089",
    "name": "Jesús Carranza"
  },
  {
    "code": "MX-JAL-048",
    "name": "Jesús María"
  },
  {
    "code": "MX-AGU-006",
    "name": "Jesús María"
  },
  {
    "code": "MX-VER-090",
    "name": "Jilotepec"
  },
  {
    "code": "MX-MEX-046",
    "name": "Jilotepec"
  },
  {
    "code": "MX-JAL-049",
    "name": "Jilotlán de los Dolores"
  },
  {
    "code": "MX-MEX-047",
    "name": "Jilotzingo"
  },
  {
    "code": "MX-MIC-043",
    "name": "Jiménez"
  },
  {
    "code": "MX-COA-014",
    "name": "Jiménez"
  },
  {
    "code": "MX-TAM-019",
    "name": "Jiménez"
  },
  {
    "code": "MX-CHH-035",
    "name": "Jiménez"
  },
  {
    "code": "MX-ZAC-021",
    "name": "Jiménez del Teul"
  },
  {
    "code": "MX-MIC-044",
    "name": "Jiquilpan"
  },
  {
    "code": "MX-CHP-046",
    "name": "Jiquipilas"
  },
  {
    "code": "MX-MEX-048",
    "name": "Jiquipilco"
  },
  {
    "code": "MX-CHP-047",
    "name": "Jitotol"
  },
  {
    "code": "MX-MOR-011",
    "name": "Jiutepec"
  },
  {
    "code": "MX-JAL-050",
    "name": "Jocotepec"
  },
  {
    "code": "MX-MEX-049",
    "name": "Jocotitlán"
  },
  {
    "code": "MX-MOR-012",
    "name": "Jojutla"
  },
  {
    "code": "MX-PUE-089",
    "name": "Jolalpan"
  },
  {
    "code": "MX-MOR-013",
    "name": "Jonacatepec"
  },
  {
    "code": "MX-PUE-090",
    "name": "Jonotla"
  },
  {
    "code": "MX-TAB-011",
    "name": "Jonuta"
  },
  {
    "code": "MX-PUE-091",
    "name": "Jopala"
  },
  {
    "code": "MX-MEX-050",
    "name": "Joquicingo"
  },
  {
    "code": "MX-VER-091",
    "name": "José Azueta"
  },
  {
    "code": "MX-GRO-042",
    "name": "José Joaquin de Herrera"
  },
  {
    "code": "MX-ROO-005",
    "name": "José María Morelos"
  },
  {
    "code": "MX-MIC-045",
    "name": "José Sixto Verduzco"
  },
  {
    "code": "MX-ZAC-022",
    "name": "Juan Aldama"
  },
  {
    "code": "MX-PUE-092",
    "name": "Juan C. Bonilla"
  },
  {
    "code": "MX-PUE-093",
    "name": "Juan Galindo"
  },
  {
    "code": "MX-PUE-094",
    "name": "Juan N. Méndez"
  },
  {
    "code": "MX-GRO-043",
    "name": "Juan R. Escudero"
  },
  {
    "code": "MX-VER-092",
    "name": "Juan Rodríguez Clara"
  },
  {
    "code": "MX-JAL-051",
    "name": "Juanacatlán"
  },
  {
    "code": "MX-ZAC-023",
    "name": "Juchipila"
  },
  {
    "code": "MX-VER-093",
    "name": "Juchique de Ferrer"
  },
  {
    "code": "MX-MEX-051",
    "name": "Juchitepec"
  },
  {
    "code": "MX-JAL-052",
    "name": "Juchitlán"
  },
  {
    "code": "MX-GRO-044",
    "name": "Juchitán"
  },
  {
    "code": "MX-OAX-010",
    "name": "Juchitán"
  },
  {
    "code": "MX-CHH-036",
    "name": "Julimes"
  },
  {
    "code": "MX-MIC-046",
    "name": "Jungapeo"
  },
  {
    "code": "MX-OAX-011",
    "name": "Juquila"
  },
  {
    "code": "MX-OAX-012",
    "name": "Juxtlahuaca"
  },
  {
    "code": "MX-MIC-047",
    "name": "Juárez"
  },
  {
    "code": "MX-CHP-048",
    "name": "Juárez"
  },
  {
    "code": "MX-NLE-029",
    "name": "Juárez"
  },
  {
    "code": "MX-COA-015",
    "name": "Juárez"
  },
  {
    "code": "MX-CHH-037",
    "name": "Juárez"
  },
  {
    "code": "MX-HID-033",
    "name": "Juárez Hidalgo"
  },
  {
    "code": "MX-VER-094",
    "name": "Jáltipan"
  },
  {
    "code": "MX-YUC-041",
    "name": "Kanasín"
  },
  {
    "code": "MX-YUC-042",
    "name": "Kantunil"
  },
  {
    "code": "MX-YUC-043",
    "name": "Kaua"
  },
  {
    "code": "MX-YUC-044",
    "name": "Kinchil"
  },
  {
    "code": "MX-YUC-045",
    "name": "Kopomá"
  },
  {
    "code": "MX-VER-095",
    "name": "La Antigua"
  },
  {
    "code": "MX-JAL-053",
    "name": "La Barca"
  },
  {
    "code": "MX-SON-037",
    "name": "La Colorada"
  },
  {
    "code": "MX-CHP-049",
    "name": "La Concordia"
  },
  {
    "code": "MX-CHH-038",
    "name": "La Cruz"
  },
  {
    "code": "MX-CHP-050",
    "name": "La Grandeza"
  },
  {
    "code": "MX-MIC-048",
    "name": "La Huacana"
  },
  {
    "code": "MX-JAL-054",
    "name": "La Huerta"
  },
  {
    "code": "MX-CHP-051",
    "name": "La Independencia"
  },
  {
    "code": "MX-CHP-052",
    "name": "La Libertad"
  },
  {
    "code": "MX-DIF-009",
    "name": "La Magdalena Contreras"
  },
  {
    "code": "MX-TLA-020",
    "name": "La Magdalena Tlaltelulco"
  },
  {
    "code": "MX-PUE-095",
    "name": "La Magdalena Tlatlauquitepec"
  },
  {
    "code": "MX-JAL-055",
    "name": "La Manzanilla de la Paz"
  },
  {
    "code": "MX-HID-034",
    "name": "La Misión"
  },
  {
    "code": "MX-MEX-052",
    "name": "La Paz"
  },
  {
    "code": "MX-BCS-002",
    "name": "La Paz"
  },
  {
    "code": "MX-VER-096",
    "name": "La Perla"
  },
  {
    "code": "MX-MIC-049",
    "name": "La Piedad"
  },
  {
    "code": "MX-CHP-053",
    "name": "La Trinitaria"
  },
  {
    "code": "MX-GRO-045",
    "name": "La Unión de Isidoro Montes de Oca"
  },
  {
    "code": "MX-NAY-010",
    "name": "La Yesca"
  },
  {
    "code": "MX-PUE-096",
    "name": "Lafragua"
  },
  {
    "code": "MX-JAL-056",
    "name": "Lagos de Moreno"
  },
  {
    "code": "MX-MIC-050",
    "name": "Lagunillas"
  },
  {
    "code": "MX-SLP-020",
    "name": "Lagunillas"
  },
  {
    "code": "MX-COA-016",
    "name": "Lamadrid"
  },
  {
    "code": "MX-NLE-030",
    "name": "Lampazos de Naranjo"
  },
  {
    "code": "MX-QUE-010",
    "name": "Landa de Matamoros"
  },
  {
    "code": "MX-VER-097",
    "name": "Landero y Coss"
  },
  {
    "code": "MX-CHP-054",
    "name": "Larráinzar"
  },
  {
    "code": "MX-VER-098",
    "name": "Las Choapas"
  },
  {
    "code": "MX-CHP-055",
    "name": "Las Margaritas"
  },
  {
    "code": "MX-VER-099",
    "name": "Las Minas"
  },
  {
    "code": "MX-CHP-056",
    "name": "Las Rosas"
  },
  {
    "code": "MX-VER-100",
    "name": "Las Vigas de Ramírez"
  },
  {
    "code": "MX-GRO-046",
    "name": "Leonardo Bravo"
  },
  {
    "code": "MX-DUR-013",
    "name": "Lerdo"
  },
  {
    "code": "MX-VER-101",
    "name": "Lerdo de Tejada"
  },
  {
    "code": "MX-MEX-053",
    "name": "Lerma"
  },
  {
    "code": "MX-GUA-018",
    "name": "León"
  },
  {
    "code": "MX-PUE-097",
    "name": "Libres"
  },
  {
    "code": "MX-NLE-031",
    "name": "Linares"
  },
  {
    "code": "MX-TAM-020",
    "name": "Llera"
  },
  {
    "code": "MX-HID-035",
    "name": "Lolotla"
  },
  {
    "code": "MX-ZAC-024",
    "name": "Loreto"
  },
  {
    "code": "MX-BCS-003",
    "name": "Loreto"
  },
  {
    "code": "MX-NLE-032",
    "name": "Los Aldamas"
  },
  {
    "code": "MX-BCS-004",
    "name": "Los Cabos"
  },
  {
    "code": "MX-NLE-033",
    "name": "Los Herreras"
  },
  {
    "code": "MX-NLE-034",
    "name": "Los Ramones"
  },
  {
    "code": "MX-VER-102",
    "name": "Los Reyes"
  },
  {
    "code": "MX-MIC-051",
    "name": "Los Reyes"
  },
  {
    "code": "MX-PUE-098",
    "name": "Los Reyes de Juárez"
  },
  {
    "code": "MX-ZAC-025",
    "name": "Luis Moya"
  },
  {
    "code": "MX-MEX-054",
    "name": "Luvianos"
  },
  {
    "code": "MX-ROO-006",
    "name": "Lázaro Cárdenas"
  },
  {
    "code": "MX-TLA-021",
    "name": "Lázaro Cárdenas"
  },
  {
    "code": "MX-MIC-052",
    "name": "Lázaro Cárdenas"
  },
  {
    "code": "MX-CHH-039",
    "name": "López"
  },
  {
    "code": "MX-TAB-012",
    "name": "Macuspana"
  },
  {
    "code": "MX-CHH-040",
    "name": "Madera"
  },
  {
    "code": "MX-MIC-053",
    "name": "Madero"
  },
  {
    "code": "MX-VER-103",
    "name": "Magdalena"
  },
  {
    "code": "MX-JAL-057",
    "name": "Magdalena"
  },
  {
    "code": "MX-SON-038",
    "name": "Magdalena"
  },
  {
    "code": "MX-CHH-041",
    "name": "Maguarichi"
  },
  {
    "code": "MX-TAM-021",
    "name": "Mainero"
  },
  {
    "code": "MX-MEX-055",
    "name": "Malinalco"
  },
  {
    "code": "MX-GRO-047",
    "name": "Malinaltepec"
  },
  {
    "code": "MX-VER-104",
    "name": "Maltrata"
  },
  {
    "code": "MX-YUC-046",
    "name": "Mama"
  },
  {
    "code": "MX-VER-105",
    "name": "Manlio Fabio Altamirano"
  },
  {
    "code": "MX-CHH-042",
    "name": "Manuel Benavides"
  },
  {
    "code": "MX-GUA-019",
    "name": "Manuel Doblado"
  },
  {
    "code": "MX-COL-007",
    "name": "Manzanillo"
  },
  {
    "code": "MX-YUC-047",
    "name": "Maní"
  },
  {
    "code": "MX-CHP-057",
    "name": "Mapastepec"
  },
  {
    "code": "MX-DUR-014",
    "name": "Mapimí"
  },
  {
    "code": "MX-MIC-054",
    "name": "Maravatío"
  },
  {
    "code": "MX-CHP-058",
    "name": "Maravilla Tenejapa"
  },
  {
    "code": "MX-MIC-055",
    "name": "Marcos Castellanos"
  },
  {
    "code": "MX-VER-106",
    "name": "Mariano Escobedo"
  },
  {
    "code": "MX-GRO-048",
    "name": "Marquelia"
  },
  {
    "code": "MX-CHP-059",
    "name": "Marqués de Comillas"
  },
  {
    "code": "MX-VER-107",
    "name": "Martínez de la Torre"
  },
  {
    "code": "MX-NLE-035",
    "name": "Marín"
  },
  {
    "code": "MX-JAL-058",
    "name": "Mascota"
  },
  {
    "code": "MX-CHH-043",
    "name": "Matachí"
  },
  {
    "code": "MX-COA-017",
    "name": "Matamoros"
  },
  {
    "code": "MX-TAM-022",
    "name": "Matamoros"
  },
  {
    "code": "MX-CHH-044",
    "name": "Matamoros"
  },
  {
    "code": "MX-SLP-021",
    "name": "Matehuala"
  },
  {
    "code": "MX-SLP-022",
    "name": "Matlapa"
  },
  {
    "code": "MX-YUC-048",
    "name": "Maxcanú"
  },
  {
    "code": "MX-YUC-049",
    "name": "Mayapán"
  },
  {
    "code": "MX-JAL-059",
    "name": "Mazamitla"
  },
  {
    "code": "MX-CHP-060",
    "name": "Mazapa de Madero"
  },
  {
    "code": "MX-ZAC-026",
    "name": "Mazapil"
  },
  {
    "code": "MX-PUE-099",
    "name": "Mazapiltepec de Juárez"
  },
  {
    "code": "MX-TLA-022",
    "name": "Mazatecochco de José María Morelos"
  },
  {
    "code": "MX-MOR-014",
    "name": "Mazatepec"
  },
  {
    "code": "MX-SIN-012",
    "name": "Mazatlán"
  },
  {
    "code": "MX-CHP-061",
    "name": "Mazatán"
  },
  {
    "code": "MX-SON-039",
    "name": "Mazatán"
  },
  {
    "code": "MX-VER-108",
    "name": "Mecatlán"
  },
  {
    "code": "MX-VER-109",
    "name": "Mecayapan"
  },
  {
    "code": "MX-VER-110",
    "name": "Medellín"
  },
  {
    "code": "MX-ZAC-027",
    "name": "Melchor Ocampo"
  },
  {
    "code": "MX-MEX-056",
    "name": "Melchor Ocampo"
  },
  {
    "code": "MX-NLE-036",
    "name": "Melchor Ocampo"
  },
  {
    "code": "MX-CHH-045",
    "name": "Meoqui"
  },
  {
    "code": "MX-CHP-062",
    "name": "Metapa"
  },
  {
    "code": "MX-MEX-057",
    "name": "Metepec"
  },
  {
    "code": "MX-HID-036",
    "name": "Metepec"
  },
  {
    "code": "MX-GRO-049",
    "name": "Metlatónoc"
  },
  {
    "code": "MX-HID-037",
    "name": "Metztitlán"
  },
  {
    "code": "MX-BCN-002",
    "name": "Mexicali"
  },
  {
    "code": "MX-MEX-058",
    "name": "Mexicaltzingo"
  },
  {
    "code": "MX-SLP-023",
    "name": "Mexquitic de Carmona"
  },
  {
    "code": "MX-JAL-060",
    "name": "Mexticacán"
  },
  {
    "code": "MX-DUR-015",
    "name": "Mezquital"
  },
  {
    "code": "MX-ZAC-028",
    "name": "Mezquital del Oro"
  },
  {
    "code": "MX-JAL-061",
    "name": "Mezquitic"
  },
  {
    "code": "MX-MOR-015",
    "name": "Miacatlán"
  },
  {
    "code": "MX-VER-111",
    "name": "Miahuatlán"
  },
  {
    "code": "MX-OAX-013",
    "name": "Miahuatlán"
  },
  {
    "code": "MX-TAM-044",
    "name": "Miahuatlán"
  },
  {
    "code": "MX-SON-074",
    "name": "Miahuatlán"
  },
  {
    "code": "MX-TAM-023",
    "name": "Mier"
  },
  {
    "code": "MX-NLE-037",
    "name": "Mier y Noriega"
  },
  {
    "code": "MX-TAM-024",
    "name": "Miguel Alemán"
  },
  {
    "code": "MX-ZAC-029",
    "name": "Miguel Auza"
  },
  {
    "code": "MX-DIF-010",
    "name": "Miguel Hidalgo"
  },
  {
    "code": "MX-DIF-011",
    "name": "Milpa Alta"
  },
  {
    "code": "MX-NLE-038",
    "name": "Mina"
  },
  {
    "code": "MX-COL-008",
    "name": "Minatitlán"
  },
  {
    "code": "MX-VER-112",
    "name": "Minatitlán"
  },
  {
    "code": "MX-HID-038",
    "name": "Mineral de la Reforma"
  },
  {
    "code": "MX-HID-039",
    "name": "Mineral del Chico"
  },
  {
    "code": "MX-HID-040",
    "name": "Mineral del Monte"
  },
  {
    "code": "MX-TAM-025",
    "name": "Miquihuana"
  },
  {
    "code": "MX-VER-113",
    "name": "Misantla"
  },
  {
    "code": "MX-CHP-063",
    "name": "Mitontic"
  },
  {
    "code": "MX-OAX-014",
    "name": "Mixe"
  },
  {
    "code": "MX-HID-041",
    "name": "Mixquiahuala de Juárez"
  },
  {
    "code": "MX-PUE-100",
    "name": "Mixtla"
  },
  {
    "code": "MX-VER-114",
    "name": "Mixtla de Altamirano"
  },
  {
    "code": "MX-JAL-062",
    "name": "Mixtlán"
  },
  {
    "code": "MX-GRO-050",
    "name": "Mochitlán"
  },
  {
    "code": "MX-YUC-050",
    "name": "Mocochá"
  },
  {
    "code": "MX-SIN-013",
    "name": "Mocorito"
  },
  {
    "code": "MX-SLP-024",
    "name": "Moctezuma"
  },
  {
    "code": "MX-SON-040",
    "name": "Moctezuma"
  },
  {
    "code": "MX-HID-042",
    "name": "Molango"
  },
  {
    "code": "MX-PUE-101",
    "name": "Molcaxac"
  },
  {
    "code": "MX-VER-115",
    "name": "Moloacán"
  },
  {
    "code": "MX-ZAC-030",
    "name": "Momax"
  },
  {
    "code": "MX-COA-018",
    "name": "Monclova"
  },
  {
    "code": "MX-ZAC-031",
    "name": "Monte Escobedo"
  },
  {
    "code": "MX-CHP-064",
    "name": "Montecristo de Guerrero"
  },
  {
    "code": "MX-NLE-039",
    "name": "Montemorelos"
  },
  {
    "code": "MX-NLE-040",
    "name": "Monterrey"
  },
  {
    "code": "MX-MIC-056",
    "name": "Morelia"
  },
  {
    "code": "MX-ZAC-032",
    "name": "Morelos"
  },
  {
    "code": "MX-MEX-059",
    "name": "Morelos"
  },
  {
    "code": "MX-COA-019",
    "name": "Morelos"
  },
  {
    "code": "MX-CHH-046",
    "name": "Morelos"
  },
  {
    "code": "MX-MIC-057",
    "name": "Morelos"
  },
  {
    "code": "MX-CHH-047",
    "name": "Moris"
  },
  {
    "code": "MX-GUA-020",
    "name": "Moroleón"
  },
  {
    "code": "MX-CHP-065",
    "name": "Motozintla"
  },
  {
    "code": "MX-YUC-051",
    "name": "Motul"
  },
  {
    "code": "MX-ZAC-033",
    "name": "Moyahua de Estrada"
  },
  {
    "code": "MX-BCS-005",
    "name": "Mulegé"
  },
  {
    "code": "MX-YUC-052",
    "name": "Muna"
  },
  {
    "code": "MX-YUC-053",
    "name": "Muxupip"
  },
  {
    "code": "MX-TLA-023",
    "name": "Muñoz de Domingo Arenas"
  },
  {
    "code": "MX-GRO-051",
    "name": "Mártir de Cuilapan"
  },
  {
    "code": "MX-TAM-026",
    "name": "Méndez"
  },
  {
    "code": "MX-YUC-054",
    "name": "Mérida"
  },
  {
    "code": "MX-MIC-058",
    "name": "Múgica"
  },
  {
    "code": "MX-COA-020",
    "name": "Múzquiz"
  },
  {
    "code": "MX-TAB-013",
    "name": "Nacajuca"
  },
  {
    "code": "MX-SON-041",
    "name": "Naco"
  },
  {
    "code": "MX-SON-042",
    "name": "Nacozari de García"
  },
  {
    "code": "MX-COA-021",
    "name": "Nadadores"
  },
  {
    "code": "MX-MIC-059",
    "name": "Nahuatzen"
  },
  {
    "code": "MX-CHH-048",
    "name": "Namiquipa"
  },
  {
    "code": "MX-TLA-024",
    "name": "Nanacamilpa de Mariano Arista"
  },
  {
    "code": "MX-VER-116",
    "name": "Nanchital"
  },
  {
    "code": "MX-VER-117",
    "name": "Naolinco"
  },
  {
    "code": "MX-VER-118",
    "name": "Naranjal"
  },
  {
    "code": "MX-VER-119",
    "name": "Naranjos Amatlán"
  },
  {
    "code": "MX-TLA-025",
    "name": "Natívitas"
  },
  {
    "code": "MX-MEX-060",
    "name": "Naucalpan de Juárez"
  },
  {
    "code": "MX-PUE-102",
    "name": "Naupan"
  },
  {
    "code": "MX-VER-120",
    "name": "Nautla"
  },
  {
    "code": "MX-PUE-103",
    "name": "Nauzontla"
  },
  {
    "code": "MX-COA-022",
    "name": "Nava"
  },
  {
    "code": "MX-SON-043",
    "name": "Navojoa"
  },
  {
    "code": "MX-SIN-014",
    "name": "Navolato"
  },
  {
    "code": "MX-DUR-016",
    "name": "Nazas"
  },
  {
    "code": "MX-PUE-104",
    "name": "Nealtican"
  },
  {
    "code": "MX-MEX-061",
    "name": "Nextlalpan"
  },
  {
    "code": "MX-MEX-062",
    "name": "Nezahualcóyotl"
  },
  {
    "code": "MX-PUE-105",
    "name": "Nicolás Bravo"
  },
  {
    "code": "MX-HID-043",
    "name": "Nicolás Flores"
  },
  {
    "code": "MX-MEX-063",
    "name": "Nicolás Romero"
  },
  {
    "code": "MX-CHP-066",
    "name": "Nicolás Ruíz"
  },
  {
    "code": "MX-ZAC-034",
    "name": "Nochistlán de Mejía"
  },
  {
    "code": "MX-OAX-015",
    "name": "Nochixtlán"
  },
  {
    "code": "MX-MIC-060",
    "name": "Nocupétaro"
  },
  {
    "code": "MX-VER-121",
    "name": "Nogales"
  },
  {
    "code": "MX-SON-044",
    "name": "Nogales"
  },
  {
    "code": "MX-DUR-017",
    "name": "Nombre de Dios"
  },
  {
    "code": "MX-CHH-049",
    "name": "Nonoava"
  },
  {
    "code": "MX-HID-044",
    "name": "Nopala"
  },
  {
    "code": "MX-MEX-064",
    "name": "Nopaltepec"
  },
  {
    "code": "MX-PUE-106",
    "name": "Nopalucan"
  },
  {
    "code": "MX-ZAC-035",
    "name": "Noria de Ángeles"
  },
  {
    "code": "MX-CHH-050",
    "name": "Nuevo Casas Grandes"
  },
  {
    "code": "MX-DUR-018",
    "name": "Nuevo Ideal"
  },
  {
    "code": "MX-TAM-027",
    "name": "Nuevo Laredo"
  },
  {
    "code": "MX-TAM-028",
    "name": "Nuevo Morelos"
  },
  {
    "code": "MX-MIC-061",
    "name": "Nuevo Parangaricutiro"
  },
  {
    "code": "MX-MIC-062",
    "name": "Nuevo Urecho"
  },
  {
    "code": "MX-MIC-063",
    "name": "Numarán"
  },
  {
    "code": "MX-SON-045",
    "name": "Nácori Chico"
  },
  {
    "code": "MX-GUA-021",
    "name": "Ocampo"
  },
  {
    "code": "MX-DUR-019",
    "name": "Ocampo"
  },
  {
    "code": "MX-COA-023",
    "name": "Ocampo"
  },
  {
    "code": "MX-TAM-029",
    "name": "Ocampo"
  },
  {
    "code": "MX-CHH-051",
    "name": "Ocampo"
  },
  {
    "code": "MX-MIC-064",
    "name": "Ocampo"
  },
  {
    "code": "MX-CHP-067",
    "name": "Ocosingo"
  },
  {
    "code": "MX-CHP-068",
    "name": "Ocotepec"
  },
  {
    "code": "MX-PUE-107",
    "name": "Ocotepec"
  },
  {
    "code": "MX-OAX-016",
    "name": "Ocotlán"
  },
  {
    "code": "MX-JAL-063",
    "name": "Ocotlán"
  },
  {
    "code": "MX-MEX-065",
    "name": "Ocoyoacac"
  },
  {
    "code": "MX-PUE-108",
    "name": "Ocoyucan"
  },
  {
    "code": "MX-CHP-069",
    "name": "Ocozocoautla de Espinosa"
  },
  {
    "code": "MX-MEX-066",
    "name": "Ocuilan"
  },
  {
    "code": "MX-MOR-016",
    "name": "Ocuituco"
  },
  {
    "code": "MX-CHH-052",
    "name": "Ojinaga"
  },
  {
    "code": "MX-ZAC-036",
    "name": "Ojocaliente"
  },
  {
    "code": "MX-JAL-064",
    "name": "Ojuelos de Jalisco"
  },
  {
    "code": "MX-GRO-052",
    "name": "Olinalá"
  },
  {
    "code": "MX-PUE-109",
    "name": "Olintla"
  },
  {
    "code": "MX-VER-122",
    "name": "Oluta"
  },
  {
    "code": "MX-VER-123",
    "name": "Omealca"
  },
  {
    "code": "MX-GRO-053",
    "name": "Ometepec"
  },
  {
    "code": "MX-HID-045",
    "name": "Omitlán de Juárez"
  },
  {
    "code": "MX-SON-046",
    "name": "Onavas"
  },
  {
    "code": "MX-YUC-055",
    "name": "Opichén"
  },
  {
    "code": "MX-SON-047",
    "name": "Opodepe"
  },
  {
    "code": "MX-SON-048",
    "name": "Oquitoa"
  },
  {
    "code": "MX-PUE-110",
    "name": "Oriental"
  },
  {
    "code": "MX-VER-124",
    "name": "Orizaba"
  },
  {
    "code": "MX-HID-053",
    "name": "Orizatlán"
  },
  {
    "code": "MX-CHP-070",
    "name": "Ostuacán"
  },
  {
    "code": "MX-CHP-071",
    "name": "Osumacinta"
  },
  {
    "code": "MX-VER-125",
    "name": "Otatitlán"
  },
  {
    "code": "MX-VER-126",
    "name": "Oteapan"
  },
  {
    "code": "MX-ROO-007",
    "name": "Othón P. Blanco"
  },
  {
    "code": "MX-MEX-067",
    "name": "Otumba"
  },
  {
    "code": "MX-MEX-068",
    "name": "Otzoloapan"
  },
  {
    "code": "MX-MEX-069",
    "name": "Otzolotepec"
  },
  {
    "code": "MX-DUR-020",
    "name": "Otáez"
  },
  {
    "code": "MX-CHP-072",
    "name": "Oxchuc"
  },
  {
    "code": "MX-YUC-056",
    "name": "Oxkutzcab"
  },
  {
    "code": "MX-VER-127",
    "name": "Ozuluama de Mascareñas"
  },
  {
    "code": "MX-MEX-070",
    "name": "Ozumba"
  },
  {
    "code": "MX-AGU-007",
    "name": "Pabellón de Arteaga"
  },
  {
    "code": "MX-HID-046",
    "name": "Pachuca"
  },
  {
    "code": "MX-HID-047",
    "name": "Pacula"
  },
  {
    "code": "MX-TAM-030",
    "name": "Padilla"
  },
  {
    "code": "MX-PUE-111",
    "name": "Pahuatlán"
  },
  {
    "code": "MX-MIC-065",
    "name": "Pajacuarán"
  },
  {
    "code": "MX-VER-128",
    "name": "Pajapan"
  },
  {
    "code": "MX-CHP-073",
    "name": "Palenque"
  },
  {
    "code": "MX-CAM-010",
    "name": "Palizada"
  },
  {
    "code": "MX-PUE-112",
    "name": "Palmar de Bravo"
  },
  {
    "code": "MX-TAM-031",
    "name": "Palmillas"
  },
  {
    "code": "MX-YUC-057",
    "name": "Panabá"
  },
  {
    "code": "MX-MIC-066",
    "name": "Panindícuaro"
  },
  {
    "code": "MX-TLA-026",
    "name": "Panotla"
  },
  {
    "code": "MX-CHP-074",
    "name": "Pantelhó"
  },
  {
    "code": "MX-CHP-075",
    "name": "Pantepec"
  },
  {
    "code": "MX-PUE-113",
    "name": "Pantepec"
  },
  {
    "code": "MX-MEX-071",
    "name": "Papalotla"
  },
  {
    "code": "MX-TLA-027",
    "name": "Papalotla de Xicohténcatl"
  },
  {
    "code": "MX-VER-129",
    "name": "Papantla"
  },
  {
    "code": "MX-MIC-067",
    "name": "Paracho"
  },
  {
    "code": "MX-TAB-014",
    "name": "Paraíso"
  },
  {
    "code": "MX-COA-024",
    "name": "Parras"
  },
  {
    "code": "MX-MIC-068",
    "name": "Parácuaro"
  },
  {
    "code": "MX-NLE-041",
    "name": "Parás"
  },
  {
    "code": "MX-VER-130",
    "name": "Paso de Ovejas"
  },
  {
    "code": "MX-VER-131",
    "name": "Paso del Macho"
  },
  {
    "code": "MX-GRO-054",
    "name": "Pedro Ascencio Alquisiras"
  },
  {
    "code": "MX-QUE-011",
    "name": "Pedro Escobedo"
  },
  {
    "code": "MX-MIC-069",
    "name": "Penjamillo"
  },
  {
    "code": "MX-MIC-070",
    "name": "Peribán"
  },
  {
    "code": "MX-VER-132",
    "name": "Perote"
  },
  {
    "code": "MX-NLE-042",
    "name": "Pesquería"
  },
  {
    "code": "MX-GRO-055",
    "name": "Petatlán"
  },
  {
    "code": "MX-PUE-114",
    "name": "Petlalcingo"
  },
  {
    "code": "MX-YUC-058",
    "name": "Peto"
  },
  {
    "code": "MX-QUE-012",
    "name": "Peñamiller"
  },
  {
    "code": "MX-DUR-021",
    "name": "Peñón Blanco"
  },
  {
    "code": "MX-PUE-115",
    "name": "Piaxtla"
  },
  {
    "code": "MX-CHP-076",
    "name": "Pichucalco"
  },
  {
    "code": "MX-COA-025",
    "name": "Piedras Negras"
  },
  {
    "code": "MX-JAL-065",
    "name": "Pihuamo"
  },
  {
    "code": "MX-CHP-077",
    "name": "Pijijiapan"
  },
  {
    "code": "MX-GRO-056",
    "name": "Pilcaya"
  },
  {
    "code": "MX-QUE-013",
    "name": "Pinal de Amoles"
  },
  {
    "code": "MX-ZAC-037",
    "name": "Pinos"
  },
  {
    "code": "MX-HID-048",
    "name": "Pisaflores"
  },
  {
    "code": "MX-SON-049",
    "name": "Pitiquito"
  },
  {
    "code": "MX-VER-133",
    "name": "Platón Sánchez"
  },
  {
    "code": "MX-VER-134",
    "name": "Playa Vicente"
  },
  {
    "code": "MX-BCN-003",
    "name": "Playas de Rosarito"
  },
  {
    "code": "MX-DUR-022",
    "name": "Poanas"
  },
  {
    "code": "MX-OAX-017",
    "name": "Pochutla"
  },
  {
    "code": "MX-MEX-072",
    "name": "Polotitlán"
  },
  {
    "code": "MX-JAL-066",
    "name": "Poncitlán"
  },
  {
    "code": "MX-VER-135",
    "name": "Poza Rica"
  },
  {
    "code": "MX-CHH-053",
    "name": "Praxedis G. Guerrero"
  },
  {
    "code": "MX-YUC-059",
    "name": "Progreso"
  },
  {
    "code": "MX-COA-026",
    "name": "Progreso"
  },
  {
    "code": "MX-HID-049",
    "name": "Progreso de Obregón"
  },
  {
    "code": "MX-PUE-116",
    "name": "Puebla"
  },
  {
    "code": "MX-GUA-022",
    "name": "Pueblo Nuevo"
  },
  {
    "code": "MX-DUR-023",
    "name": "Pueblo Nuevo"
  },
  {
    "code": "MX-CHP-078",
    "name": "Pueblo Nuevo Solistahuacán"
  },
  {
    "code": "MX-VER-136",
    "name": "Pueblo Viejo"
  },
  {
    "code": "MX-MOR-017",
    "name": "Puente de Ixtla"
  },
  {
    "code": "MX-VER-137",
    "name": "Puente Nacional"
  },
  {
    "code": "MX-SON-050",
    "name": "Puerto Peñasco"
  },
  {
    "code": "MX-JAL-067",
    "name": "Puerto Vallarta"
  },
  {
    "code": "MX-GRO-057",
    "name": "Pungarabato"
  },
  {
    "code": "MX-MIC-071",
    "name": "Puruándiro"
  },
  {
    "code": "MX-MIC-072",
    "name": "Purépero"
  },
  {
    "code": "MX-GUA-023",
    "name": "Purísima del Rincón"
  },
  {
    "code": "MX-OAX-018",
    "name": "Putla"
  },
  {
    "code": "MX-ZAC-038",
    "name": "Pánuco"
  },
  {
    "code": "MX-VER-138",
    "name": "Pánuco"
  },
  {
    "code": "MX-DUR-024",
    "name": "Pánuco de Coronado"
  },
  {
    "code": "MX-MIC-073",
    "name": "Pátzcuaro"
  },
  {
    "code": "MX-GUA-024",
    "name": "Pénjamo"
  },
  {
    "code": "MX-PUE-117",
    "name": "Quecholac"
  },
  {
    "code": "MX-GRO-058",
    "name": "Quechultenango"
  },
  {
    "code": "MX-MIC-074",
    "name": "Queréndaro"
  },
  {
    "code": "MX-QUE-014",
    "name": "Querétaro"
  },
  {
    "code": "MX-PUE-118",
    "name": "Quimixtlán"
  },
  {
    "code": "MX-YUC-060",
    "name": "Quintana Roo"
  },
  {
    "code": "MX-SON-051",
    "name": "Quiriego"
  },
  {
    "code": "MX-MIC-075",
    "name": "Quiroga"
  },
  {
    "code": "MX-JAL-068",
    "name": "Quitupan"
  },
  {
    "code": "MX-VER-139",
    "name": "Rafael Delgado"
  },
  {
    "code": "MX-PUE-119",
    "name": "Rafael Lara Grajales"
  },
  {
    "code": "MX-VER-140",
    "name": "Rafael Lucio"
  },
  {
    "code": "MX-COA-027",
    "name": "Ramos Arizpe"
  },
  {
    "code": "MX-NLE-043",
    "name": "Rayones"
  },
  {
    "code": "MX-MEX-073",
    "name": "Rayón"
  },
  {
    "code": "MX-CHP-079",
    "name": "Rayón"
  },
  {
    "code": "MX-SLP-025",
    "name": "Rayón"
  },
  {
    "code": "MX-SON-052",
    "name": "Rayón"
  },
  {
    "code": "MX-CHP-080",
    "name": "Reforma"
  },
  {
    "code": "MX-TAM-032",
    "name": "Reynosa"
  },
  {
    "code": "MX-AGU-008",
    "name": "Rincón de Romos"
  },
  {
    "code": "MX-SLP-026",
    "name": "Rioverde"
  },
  {
    "code": "MX-CHH-054",
    "name": "Riva Palacio"
  },
  {
    "code": "MX-DUR-025",
    "name": "Rodeo"
  },
  {
    "code": "MX-GUA-025",
    "name": "Romita"
  },
  {
    "code": "MX-CHH-055",
    "name": "Rosales"
  },
  {
    "code": "MX-NAY-011",
    "name": "Rosamorada"
  },
  {
    "code": "MX-CHH-056",
    "name": "Rosario"
  },
  {
    "code": "MX-SIN-015",
    "name": "Rosario"
  },
  {
    "code": "MX-SON-053",
    "name": "Rosario"
  },
  {
    "code": "MX-NAY-012",
    "name": "Ruíz"
  },
  {
    "code": "MX-VER-141",
    "name": "Río Blanco"
  },
  {
    "code": "MX-TAM-033",
    "name": "Río Bravo"
  },
  {
    "code": "MX-ZAC-039",
    "name": "Río Grande"
  },
  {
    "code": "MX-YUC-061",
    "name": "Río Lagartos"
  },
  {
    "code": "MX-CHP-081",
    "name": "Sabanilla"
  },
  {
    "code": "MX-COA-028",
    "name": "Sabinas"
  },
  {
    "code": "MX-NLE-044",
    "name": "Sabinas Hidalgo"
  },
  {
    "code": "MX-YUC-062",
    "name": "Sacalum"
  },
  {
    "code": "MX-COA-029",
    "name": "Sacramento"
  },
  {
    "code": "MX-SON-054",
    "name": "Sahuaripa"
  },
  {
    "code": "MX-MIC-076",
    "name": "Sahuayo"
  },
  {
    "code": "MX-ZAC-040",
    "name": "Sain Alto"
  },
  {
    "code": "MX-GUA-026",
    "name": "Salamanca"
  },
  {
    "code": "MX-SLP-027",
    "name": "Salinas"
  },
  {
    "code": "MX-NLE-045",
    "name": "Salinas Victoria"
  },
  {
    "code": "MX-VER-142",
    "name": "Saltabarranca"
  },
  {
    "code": "MX-COA-030",
    "name": "Saltillo"
  },
  {
    "code": "MX-CHP-082",
    "name": "Salto de Agua"
  },
  {
    "code": "MX-SIN-016",
    "name": "Salvador Alvarado"
  },
  {
    "code": "MX-MIC-077",
    "name": "Salvador Escalante"
  },
  {
    "code": "MX-GUA-027",
    "name": "Salvatierra"
  },
  {
    "code": "MX-YUC-063",
    "name": "Samahil"
  },
  {
    "code": "MX-HID-050",
    "name": "San Agustín Metzquititlán"
  },
  {
    "code": "MX-HID-051",
    "name": "San Agustín Tlaxiaca"
  },
  {
    "code": "MX-PUE-120",
    "name": "San Andrés Cholula"
  },
  {
    "code": "MX-CHP-083",
    "name": "San Andrés Duraznal"
  },
  {
    "code": "MX-VER-143",
    "name": "San Andrés Tenejapan"
  },
  {
    "code": "MX-VER-144",
    "name": "San Andrés Tuxtla"
  },
  {
    "code": "MX-SLP-028",
    "name": "San Antonio"
  },
  {
    "code": "MX-PUE-121",
    "name": "San Antonio Cañada"
  },
  {
    "code": "MX-MEX-074",
    "name": "San Antonio la Isla"
  },
  {
    "code": "MX-HID-052",
    "name": "San Bartolo Tutotepec"
  },
  {
    "code": "MX-DUR-026",
    "name": "San Bernardo"
  },
  {
    "code": "MX-NAY-013",
    "name": "San Blas"
  },
  {
    "code": "MX-COA-031",
    "name": "San Buenaventura"
  },
  {
    "code": "MX-TAM-034",
    "name": "San Carlos"
  },
  {
    "code": "MX-SLP-029",
    "name": "San Ciro de Acosta"
  },
  {
    "code": "MX-JAL-069",
    "name": "San Cristóbal de la Barranca"
  },
  {
    "code": "MX-CHP-084",
    "name": "San Cristóbal de las Casas"
  },
  {
    "code": "MX-TLA-028",
    "name": "San Damián Texóloc"
  },
  {
    "code": "MX-JAL-070",
    "name": "San Diego de Alejandría"
  },
  {
    "code": "MX-GUA-028",
    "name": "San Diego de la Unión"
  },
  {
    "code": "MX-PUE-122",
    "name": "San Diego la Meza Tochimiltzingo"
  },
  {
    "code": "MX-DUR-027",
    "name": "San Dimas"
  },
  {
    "code": "MX-GUA-029",
    "name": "San Felipe"
  },
  {
    "code": "MX-YUC-064",
    "name": "San Felipe"
  },
  {
    "code": "MX-SON-055",
    "name": "San Felipe de Jesús"
  },
  {
    "code": "MX-MEX-075",
    "name": "San Felipe del Progreso"
  },
  {
    "code": "MX-PUE-123",
    "name": "San Felipe Teotlalcingo"
  },
  {
    "code": "MX-PUE-124",
    "name": "San Felipe Tepatlán"
  },
  {
    "code": "MX-CHP-085",
    "name": "San Fernando"
  },
  {
    "code": "MX-TAM-035",
    "name": "San Fernando"
  },
  {
    "code": "MX-CHH-057",
    "name": "San Francisco de Borja"
  },
  {
    "code": "MX-CHH-058",
    "name": "San Francisco de Conchos"
  },
  {
    "code": "MX-AGU-009",
    "name": "San Francisco de los Romo"
  },
  {
    "code": "MX-CHH-059",
    "name": "San Francisco del Oro"
  },
  {
    "code": "MX-GUA-030",
    "name": "San Francisco del Rincón"
  },
  {
    "code": "MX-TLA-029",
    "name": "San Francisco Tetlanohcan"
  },
  {
    "code": "MX-JAL-071",
    "name": "San Gabriel"
  },
  {
    "code": "MX-PUE-125",
    "name": "San Gabriel Chilac"
  },
  {
    "code": "MX-PUE-126",
    "name": "San Gregorio Atzompa"
  },
  {
    "code": "MX-SIN-017",
    "name": "San Ignacio"
  },
  {
    "code": "MX-JAL-072",
    "name": "San Ignacio Cerro Gordo"
  },
  {
    "code": "MX-SON-056",
    "name": "San Ignacio Río Muerto"
  },
  {
    "code": "MX-SON-057",
    "name": "San Javier"
  },
  {
    "code": "MX-PUE-127",
    "name": "San Jerónimo Tecuanipan"
  },
  {
    "code": "MX-PUE-128",
    "name": "San Jerónimo Xayacatlán"
  },
  {
    "code": "MX-TLA-030",
    "name": "San Jerónimo Zacualpan"
  },
  {
    "code": "MX-QUE-015",
    "name": "San Joaquín"
  },
  {
    "code": "MX-PUE-129",
    "name": "San José Chiapa"
  },
  {
    "code": "MX-AGU-010",
    "name": "San José de Gracia"
  },
  {
    "code": "MX-MEX-076",
    "name": "San José del Rincón"
  },
  {
    "code": "MX-GUA-031",
    "name": "San José Iturbide"
  },
  {
    "code": "MX-PUE-130",
    "name": "San José Miahuatlán"
  },
  {
    "code": "MX-TLA-031",
    "name": "San José Teacalco"
  },
  {
    "code": "MX-PUE-131",
    "name": "San Juan Atenco"
  },
  {
    "code": "MX-PUE-132",
    "name": "San Juan Atzompa"
  },
  {
    "code": "MX-CHP-086",
    "name": "San Juan Cancuc"
  },
  {
    "code": "MX-DUR-028",
    "name": "San Juan de Guadalupe"
  },
  {
    "code": "MX-JAL-073",
    "name": "San Juan de los Lagos"
  },
  {
    "code": "MX-COA-032",
    "name": "San Juan de Sabinas"
  },
  {
    "code": "MX-DUR-040",
    "name": "San Juan del Río"
  },
  {
    "code": "MX-QUE-019",
    "name": "San Juan del Río"
  },
  {
    "code": "MX-VER-145",
    "name": "San Juan Evangelista"
  },
  {
    "code": "MX-TLA-032",
    "name": "San Juan Huactzinco"
  },
  {
    "code": "MX-JAL-074",
    "name": "San Juanito de Escobedo"
  },
  {
    "code": "MX-JAL-075",
    "name": "San Julián"
  },
  {
    "code": "MX-TLA-033",
    "name": "San Lorenzo Axocomanitla"
  },
  {
    "code": "MX-CHP-087",
    "name": "San Lucas"
  },
  {
    "code": "MX-MIC-078",
    "name": "San Lucas"
  },
  {
    "code": "MX-TLA-034",
    "name": "San Lucas Tecopilco"
  },
  {
    "code": "MX-GRO-059",
    "name": "San Luis Acatlán"
  },
  {
    "code": "MX-GUA-032",
    "name": "San Luis de la Paz"
  },
  {
    "code": "MX-DUR-030",
    "name": "San Luis del Cordero"
  },
  {
    "code": "MX-SLP-030",
    "name": "San Luis Potosí"
  },
  {
    "code": "MX-SON-058",
    "name": "San Luis Río Colorado"
  },
  {
    "code": "MX-GRO-060",
    "name": "San Marcos"
  },
  {
    "code": "MX-JAL-076",
    "name": "San Marcos"
  },
  {
    "code": "MX-SLP-031",
    "name": "San Martín Chalchicuautla"
  },
  {
    "code": "MX-JAL-078",
    "name": "San Martín de Bolaños"
  },
  {
    "code": "MX-JAL-077",
    "name": "San Martín de Hidalgo"
  },
  {
    "code": "MX-MEX-077",
    "name": "San Martín de las Pirámides"
  },
  {
    "code": "MX-PUE-133",
    "name": "San Martín Texmelucan"
  },
  {
    "code": "MX-PUE-134",
    "name": "San Martín Totoltepec"
  },
  {
    "code": "MX-MEX-078",
    "name": "San Mateo Atenco"
  },
  {
    "code": "MX-PUE-135",
    "name": "San Matías Tlalancaleca"
  },
  {
    "code": "MX-GUA-033",
    "name": "San Miguel de Allende"
  },
  {
    "code": "MX-SON-059",
    "name": "San Miguel de Horcasitas"
  },
  {
    "code": "MX-JAL-079",
    "name": "San Miguel el Alto"
  },
  {
    "code": "MX-PUE-136",
    "name": "San Miguel Ixitlán"
  },
  {
    "code": "MX-GRO-061",
    "name": "San Miguel Totolapan"
  },
  {
    "code": "MX-PUE-137",
    "name": "San Miguel Xoxtla"
  },
  {
    "code": "MX-TAM-036",
    "name": "San Nicolás"
  },
  {
    "code": "MX-PUE-138",
    "name": "San Nicolás Buenos Aires"
  },
  {
    "code": "MX-NLE-046",
    "name": "San Nicolás de los Garza"
  },
  {
    "code": "MX-PUE-139",
    "name": "San Nicolás de los Ranchos"
  },
  {
    "code": "MX-SLP-032",
    "name": "San Nicolás Tolentino"
  },
  {
    "code": "MX-PUE-140",
    "name": "San Pablo Anicano"
  },
  {
    "code": "MX-TLA-035",
    "name": "San Pablo del Monte"
  },
  {
    "code": "MX-COA-033",
    "name": "San Pedro"
  },
  {
    "code": "MX-PUE-141",
    "name": "San Pedro Cholula"
  },
  {
    "code": "MX-SON-060",
    "name": "San Pedro de la Cueva"
  },
  {
    "code": "MX-DUR-031",
    "name": "San Pedro del Gallo"
  },
  {
    "code": "MX-NLE-047",
    "name": "San Pedro Garza García"
  },
  {
    "code": "MX-NAY-014",
    "name": "San Pedro Lagunillas"
  },
  {
    "code": "MX-PUE-142",
    "name": "San Pedro Yeloixtlahuaca"
  },
  {
    "code": "MX-VER-146",
    "name": "San Rafael"
  },
  {
    "code": "MX-HID-054",
    "name": "San Salvador"
  },
  {
    "code": "MX-PUE-144",
    "name": "San Salvador el Seco"
  },
  {
    "code": "MX-PUE-145",
    "name": "San Salvador el Verde"
  },
  {
    "code": "MX-PUE-143",
    "name": "San Salvador Huixcolotla"
  },
  {
    "code": "MX-JAL-080",
    "name": "San Sebastián del Oeste"
  },
  {
    "code": "MX-PUE-146",
    "name": "San Sebastián Tlacotepec"
  },
  {
    "code": "MX-MEX-079",
    "name": "San Simón de Guerrero"
  },
  {
    "code": "MX-SLP-033",
    "name": "San Vicente Tancuayalab"
  },
  {
    "code": "MX-YUC-065",
    "name": "Sanahcat"
  },
  {
    "code": "MX-TLA-036",
    "name": "Sanctórum de Lázaro Cárdenas"
  },
  {
    "code": "MX-SON-061",
    "name": "Santa Ana"
  },
  {
    "code": "MX-MIC-079",
    "name": "Santa Ana Maya"
  },
  {
    "code": "MX-TLA-037",
    "name": "Santa Ana Nopalucan"
  },
  {
    "code": "MX-TLA-038",
    "name": "Santa Apolonia Teacalco"
  },
  {
    "code": "MX-CHH-060",
    "name": "Santa Bárbara"
  },
  {
    "code": "MX-GUA-034",
    "name": "Santa Catarina"
  },
  {
    "code": "MX-NLE-048",
    "name": "Santa Catarina"
  },
  {
    "code": "MX-SLP-034",
    "name": "Santa Catarina"
  },
  {
    "code": "MX-TLA-039",
    "name": "Santa Catarina Ayometla"
  },
  {
    "code": "MX-PUE-147",
    "name": "Santa Catarina Tlaltempan"
  },
  {
    "code": "MX-DUR-032",
    "name": "Santa Clara"
  },
  {
    "code": "MX-SON-062",
    "name": "Santa Cruz"
  },
  {
    "code": "MX-GUA-035",
    "name": "Santa Cruz de Juventino Rosas"
  },
  {
    "code": "MX-TLA-040",
    "name": "Santa Cruz Quilehtla"
  },
  {
    "code": "MX-TLA-041",
    "name": "Santa Cruz Tlaxcala"
  },
  {
    "code": "MX-YUC-066",
    "name": "Santa Elena"
  },
  {
    "code": "MX-PUE-148",
    "name": "Santa Inés Ahuatempan"
  },
  {
    "code": "MX-CHH-061",
    "name": "Santa Isabel"
  },
  {
    "code": "MX-PUE-149",
    "name": "Santa Isabel Cholula"
  },
  {
    "code": "MX-TLA-042",
    "name": "Santa Isabel Xiloxoxtla"
  },
  {
    "code": "MX-ZAC-041",
    "name": "Santa María de la Paz"
  },
  {
    "code": "MX-JAL-081",
    "name": "Santa María de los Ángeles"
  },
  {
    "code": "MX-NAY-015",
    "name": "Santa María del Oro"
  },
  {
    "code": "MX-JAL-082",
    "name": "Santa María del Oro"
  },
  {
    "code": "MX-SLP-035",
    "name": "Santa María del Río"
  },
  {
    "code": "MX-NLE-049",
    "name": "Santiago"
  },
  {
    "code": "MX-HID-056",
    "name": "Santiago de Anaya"
  },
  {
    "code": "MX-CHP-088",
    "name": "Santiago el Pinar"
  },
  {
    "code": "MX-NAY-016",
    "name": "Santiago Ixcuintla"
  },
  {
    "code": "MX-GUA-036",
    "name": "Santiago Maravatío"
  },
  {
    "code": "MX-PUE-150",
    "name": "Santiago Miahuatlán"
  },
  {
    "code": "MX-DUR-033",
    "name": "Santiago Papasquiaro"
  },
  {
    "code": "MX-VER-147",
    "name": "Santiago Sochiapan"
  },
  {
    "code": "MX-VER-148",
    "name": "Santiago Tuxtla"
  },
  {
    "code": "MX-SLP-036",
    "name": "Santo Domingo"
  },
  {
    "code": "MX-MEX-080",
    "name": "Santo Tomás"
  },
  {
    "code": "MX-PUE-151",
    "name": "Santo Tomás Hueyotlipan"
  },
  {
    "code": "MX-CHH-062",
    "name": "Satevó"
  },
  {
    "code": "MX-CHH-063",
    "name": "Saucillo"
  },
  {
    "code": "MX-JAL-083",
    "name": "Sayula"
  },
  {
    "code": "MX-VER-149",
    "name": "Sayula de Alemán"
  },
  {
    "code": "MX-MIC-080",
    "name": "Senguio"
  },
  {
    "code": "MX-YUC-067",
    "name": "Seyé"
  },
  {
    "code": "MX-COA-034",
    "name": "Sierra Mojada"
  },
  {
    "code": "MX-OAX-019",
    "name": "Silacayoápam"
  },
  {
    "code": "MX-GUA-037",
    "name": "Silao"
  },
  {
    "code": "MX-CHP-089",
    "name": "Siltepec"
  },
  {
    "code": "MX-CHP-090",
    "name": "Simojovel"
  },
  {
    "code": "MX-SIN-018",
    "name": "Sinaloa"
  },
  {
    "code": "MX-YUC-068",
    "name": "Sinanché"
  },
  {
    "code": "MX-HID-057",
    "name": "Singuilucan"
  },
  {
    "code": "MX-CHP-091",
    "name": "Sitalá"
  },
  {
    "code": "MX-VER-150",
    "name": "Sochiapa"
  },
  {
    "code": "MX-CHP-092",
    "name": "Socoltenango"
  },
  {
    "code": "MX-VER-151",
    "name": "Soconusco"
  },
  {
    "code": "MX-OAX-020",
    "name": "Sola de Vega"
  },
  {
    "code": "MX-VER-152",
    "name": "Soledad Atzompa"
  },
  {
    "code": "MX-VER-153",
    "name": "Soledad de Doblado"
  },
  {
    "code": "MX-SLP-037",
    "name": "Soledad de Graciano Sánchez"
  },
  {
    "code": "MX-ROO-008",
    "name": "Solidaridad"
  },
  {
    "code": "MX-CHP-093",
    "name": "Solosuchiapa"
  },
  {
    "code": "MX-PUE-152",
    "name": "Soltepec"
  },
  {
    "code": "MX-ZAC-042",
    "name": "Sombrerete"
  },
  {
    "code": "MX-VER-154",
    "name": "Soteapan"
  },
  {
    "code": "MX-TAM-037",
    "name": "Soto la Marina"
  },
  {
    "code": "MX-YUC-069",
    "name": "Sotuta"
  },
  {
    "code": "MX-CHP-094",
    "name": "Soyaló"
  },
  {
    "code": "MX-MEX-081",
    "name": "Soyaniquilpan"
  },
  {
    "code": "MX-SON-063",
    "name": "Soyopa"
  },
  {
    "code": "MX-SON-064",
    "name": "Suaqui Grande"
  },
  {
    "code": "MX-CHP-095",
    "name": "Suchiapa"
  },
  {
    "code": "MX-CHP-096",
    "name": "Suchiate"
  },
  {
    "code": "MX-YUC-070",
    "name": "Sucilá"
  },
  {
    "code": "MX-YUC-071",
    "name": "Sudzal"
  },
  {
    "code": "MX-MEX-082",
    "name": "Sultepec"
  },
  {
    "code": "MX-YUC-072",
    "name": "Suma"
  },
  {
    "code": "MX-CHP-097",
    "name": "Sunuapa"
  },
  {
    "code": "MX-ZAC-043",
    "name": "Susticacán"
  },
  {
    "code": "MX-MIC-081",
    "name": "Susupuato"
  },
  {
    "code": "MX-SON-065",
    "name": "Sáric"
  },
  {
    "code": "MX-DUR-034",
    "name": "Súchil"
  },
  {
    "code": "MX-ZAC-044",
    "name": "Tabasco"
  },
  {
    "code": "MX-TAB-015",
    "name": "Tacotalpa"
  },
  {
    "code": "MX-MIC-082",
    "name": "Tacámbaro"
  },
  {
    "code": "MX-YUC-073",
    "name": "Tahdziú"
  },
  {
    "code": "MX-YUC-074",
    "name": "Tahmek"
  },
  {
    "code": "MX-JAL-084",
    "name": "Tala"
  },
  {
    "code": "MX-JAL-085",
    "name": "Talpa de Allende"
  },
  {
    "code": "MX-VER-155",
    "name": "Tamalín"
  },
  {
    "code": "MX-SLP-038",
    "name": "Tamasopo"
  },
  {
    "code": "MX-DUR-035",
    "name": "Tamazula"
  },
  {
    "code": "MX-JAL-086",
    "name": "Tamazula de Gordiano"
  },
  {
    "code": "MX-SLP-039",
    "name": "Tamazunchale"
  },
  {
    "code": "MX-VER-156",
    "name": "Tamiahua"
  },
  {
    "code": "MX-SLP-040",
    "name": "Tampacán"
  },
  {
    "code": "MX-SLP-041",
    "name": "Tampamolón Corona"
  },
  {
    "code": "MX-TAM-038",
    "name": "Tampico"
  },
  {
    "code": "MX-VER-157",
    "name": "Tampico Alto"
  },
  {
    "code": "MX-SLP-042",
    "name": "Tamuín"
  },
  {
    "code": "MX-SLP-043",
    "name": "Tancanhuitz"
  },
  {
    "code": "MX-VER-158",
    "name": "Tancoco"
  },
  {
    "code": "MX-MIC-083",
    "name": "Tancítaro"
  },
  {
    "code": "MX-MIC-084",
    "name": "Tangamandapio"
  },
  {
    "code": "MX-MIC-085",
    "name": "Tangancícuaro"
  },
  {
    "code": "MX-MIC-086",
    "name": "Tanhuato"
  },
  {
    "code": "MX-SLP-044",
    "name": "Tanlajás"
  },
  {
    "code": "MX-SLP-045",
    "name": "Tanquián de Escobedo"
  },
  {
    "code": "MX-VER-159",
    "name": "Tantima"
  },
  {
    "code": "MX-VER-160",
    "name": "Tantoyuca"
  },
  {
    "code": "MX-CHP-098",
    "name": "Tapachula"
  },
  {
    "code": "MX-CHP-099",
    "name": "Tapalapa"
  },
  {
    "code": "MX-JAL-087",
    "name": "Tapalpa"
  },
  {
    "code": "MX-CHP-100",
    "name": "Tapilula"
  },
  {
    "code": "MX-GUA-038",
    "name": "Tarandacuao"
  },
  {
    "code": "MX-MIC-087",
    "name": "Taretan"
  },
  {
    "code": "MX-GUA-039",
    "name": "Tarimoro"
  },
  {
    "code": "MX-MIC-088",
    "name": "Tarímbaro"
  },
  {
    "code": "MX-HID-058",
    "name": "Tasquillo"
  },
  {
    "code": "MX-VER-161",
    "name": "Tatahuicapan"
  },
  {
    "code": "MX-VER-162",
    "name": "Tatatila"
  },
  {
    "code": "MX-GRO-062",
    "name": "Taxco de Alarcón"
  },
  {
    "code": "MX-YUC-075",
    "name": "Teabo"
  },
  {
    "code": "MX-TAB-016",
    "name": "Teapa"
  },
  {
    "code": "MX-PUE-153",
    "name": "Tecali de Herrera"
  },
  {
    "code": "MX-JAL-088",
    "name": "Tecalitlán"
  },
  {
    "code": "MX-PUE-154",
    "name": "Tecamachalco"
  },
  {
    "code": "MX-BCN-004",
    "name": "Tecate"
  },
  {
    "code": "MX-JAL-089",
    "name": "Techaluta de Montenegro"
  },
  {
    "code": "MX-GRO-063",
    "name": "Tecoanapa"
  },
  {
    "code": "MX-YUC-076",
    "name": "Tecoh"
  },
  {
    "code": "MX-JAL-090",
    "name": "Tecolotlán"
  },
  {
    "code": "MX-VER-163",
    "name": "Tecolutla"
  },
  {
    "code": "MX-PUE-155",
    "name": "Tecomatlán"
  },
  {
    "code": "MX-COL-009",
    "name": "Tecomán"
  },
  {
    "code": "MX-HID-059",
    "name": "Tecozautla"
  },
  {
    "code": "MX-CHP-101",
    "name": "Tecpatán"
  },
  {
    "code": "MX-NAY-017",
    "name": "Tecuala"
  },
  {
    "code": "MX-MEX-083",
    "name": "Tecámac"
  },
  {
    "code": "MX-PUE-156",
    "name": "Tehuacán"
  },
  {
    "code": "MX-OAX-021",
    "name": "Tehuantepec"
  },
  {
    "code": "MX-VER-164",
    "name": "Tehuipango"
  },
  {
    "code": "MX-PUE-157",
    "name": "Tehuitzingo"
  },
  {
    "code": "MX-MEX-084",
    "name": "Tejupilco"
  },
  {
    "code": "MX-YUC-077",
    "name": "Tekal de Venegas"
  },
  {
    "code": "MX-YUC-078",
    "name": "Tekantó"
  },
  {
    "code": "MX-YUC-079",
    "name": "Tekax"
  },
  {
    "code": "MX-YUC-080",
    "name": "Tekit"
  },
  {
    "code": "MX-YUC-081",
    "name": "Tekom"
  },
  {
    "code": "MX-YUC-082",
    "name": "Telchac Pueblo"
  },
  {
    "code": "MX-YUC-083",
    "name": "Telchac Puerto"
  },
  {
    "code": "MX-GRO-064",
    "name": "Teloloapan"
  },
  {
    "code": "MX-MEX-085",
    "name": "Temamatla"
  },
  {
    "code": "MX-MEX-086",
    "name": "Temascalapa"
  },
  {
    "code": "MX-MEX-087",
    "name": "Temascalcingo"
  },
  {
    "code": "MX-MEX-088",
    "name": "Temascaltepec"
  },
  {
    "code": "MX-YUC-084",
    "name": "Temax"
  },
  {
    "code": "MX-MOR-018",
    "name": "Temixco"
  },
  {
    "code": "MX-MOR-019",
    "name": "Temoac"
  },
  {
    "code": "MX-MEX-089",
    "name": "Temoaya"
  },
  {
    "code": "MX-YUC-085",
    "name": "Temozón"
  },
  {
    "code": "MX-VER-165",
    "name": "Tempoal"
  },
  {
    "code": "MX-CHH-064",
    "name": "Temósachic"
  },
  {
    "code": "MX-CAM-011",
    "name": "Tenabo"
  },
  {
    "code": "MX-JAL-091",
    "name": "Tenamaxtlán"
  },
  {
    "code": "MX-VER-166",
    "name": "Tenampa"
  },
  {
    "code": "MX-PUE-158",
    "name": "Tenampulco"
  },
  {
    "code": "MX-MEX-090",
    "name": "Tenancingo"
  },
  {
    "code": "MX-TLA-043",
    "name": "Tenancingo"
  },
  {
    "code": "MX-HID-060",
    "name": "Tenango de Doria"
  },
  {
    "code": "MX-MEX-091",
    "name": "Tenango del Aire"
  },
  {
    "code": "MX-MEX-092",
    "name": "Tenango del Valle"
  },
  {
    "code": "MX-CHP-102",
    "name": "Tenejapa"
  },
  {
    "code": "MX-VER-167",
    "name": "Tenochtitlán"
  },
  {
    "code": "MX-TAB-017",
    "name": "Tenosique"
  },
  {
    "code": "MX-JAL-092",
    "name": "Teocaltiche"
  },
  {
    "code": "MX-VER-168",
    "name": "Teocelo"
  },
  {
    "code": "MX-JAL-093",
    "name": "Teocuitatlán de Corona"
  },
  {
    "code": "MX-TLA-044",
    "name": "Teolocholco"
  },
  {
    "code": "MX-MEX-093",
    "name": "Teoloyucan"
  },
  {
    "code": "MX-PUE-159",
    "name": "Teopantlán"
  },
  {
    "code": "MX-CHP-103",
    "name": "Teopisca"
  },
  {
    "code": "MX-MEX-094",
    "name": "Teotihuacán"
  },
  {
    "code": "MX-OAX-022",
    "name": "Teotitlán"
  },
  {
    "code": "MX-PUE-160",
    "name": "Teotlalco"
  },
  {
    "code": "MX-SON-066",
    "name": "Tepache"
  },
  {
    "code": "MX-YUC-086",
    "name": "Tepakán"
  },
  {
    "code": "MX-MIC-089",
    "name": "Tepalcatepec"
  },
  {
    "code": "MX-MOR-020",
    "name": "Tepalcingo"
  },
  {
    "code": "MX-PUE-161",
    "name": "Tepanco de López"
  },
  {
    "code": "MX-PUE-162",
    "name": "Tepango de Rodríguez"
  },
  {
    "code": "MX-JAL-094",
    "name": "Tepatitlán"
  },
  {
    "code": "MX-VER-169",
    "name": "Tepatlaxco"
  },
  {
    "code": "MX-PUE-163",
    "name": "Tepatlaxco de Hidalgo"
  },
  {
    "code": "MX-PUE-164",
    "name": "Tepeaca"
  },
  {
    "code": "MX-HID-061",
    "name": "Tepeapulco"
  },
  {
    "code": "MX-ZAC-045",
    "name": "Tepechitlán"
  },
  {
    "code": "MX-GRO-065",
    "name": "Tepecoacuilco de Trujano"
  },
  {
    "code": "MX-HID-062",
    "name": "Tepehuacán de Guerrero"
  },
  {
    "code": "MX-DUR-036",
    "name": "Tepehuanes"
  },
  {
    "code": "MX-HID-063",
    "name": "Tepeji del Río de Ocampo"
  },
  {
    "code": "MX-PUE-165",
    "name": "Tepemaxalco"
  },
  {
    "code": "MX-PUE-166",
    "name": "Tepeojuma"
  },
  {
    "code": "MX-TLA-045",
    "name": "Tepetitla de Lardizábal"
  },
  {
    "code": "MX-HID-064",
    "name": "Tepetitlán"
  },
  {
    "code": "MX-MEX-095",
    "name": "Tepetlaoxtoc"
  },
  {
    "code": "MX-MEX-096",
    "name": "Tepetlixpa"
  },
  {
    "code": "MX-VER-170",
    "name": "Tepetlán"
  },
  {
    "code": "MX-ZAC-046",
    "name": "Tepetongo"
  },
  {
    "code": "MX-VER-171",
    "name": "Tepetzintla"
  },
  {
    "code": "MX-PUE-167",
    "name": "Tepetzintla"
  },
  {
    "code": "MX-PUE-168",
    "name": "Tepexco"
  },
  {
    "code": "MX-PUE-169",
    "name": "Tepexi de Rodríguez"
  },
  {
    "code": "MX-PUE-170",
    "name": "Tepeyahualco"
  },
  {
    "code": "MX-PUE-171",
    "name": "Tepeyahualco de Cuauhtémoc"
  },
  {
    "code": "MX-TLA-046",
    "name": "Tepeyanco"
  },
  {
    "code": "MX-AGU-011",
    "name": "Tepezalá"
  },
  {
    "code": "MX-NAY-018",
    "name": "Tepic"
  },
  {
    "code": "MX-OAX-023",
    "name": "Teposcolula"
  },
  {
    "code": "MX-MEX-097",
    "name": "Tepotzotlán"
  },
  {
    "code": "MX-MOR-021",
    "name": "Tepoztlán"
  },
  {
    "code": "MX-VER-172",
    "name": "Tequila"
  },
  {
    "code": "MX-JAL-095",
    "name": "Tequila"
  },
  {
    "code": "MX-QUE-017",
    "name": "Tequisquiapan"
  },
  {
    "code": "MX-MEX-098",
    "name": "Tequixquiac"
  },
  {
    "code": "MX-TLA-047",
    "name": "Terrenate"
  },
  {
    "code": "MX-MOR-022",
    "name": "Tetecala"
  },
  {
    "code": "MX-PUE-172",
    "name": "Tetela de Ocampo"
  },
  {
    "code": "MX-MOR-023",
    "name": "Tetela del Volcán"
  },
  {
    "code": "MX-PUE-173",
    "name": "Teteles de Avila Castillo"
  },
  {
    "code": "MX-HID-065",
    "name": "Tetepango"
  },
  {
    "code": "MX-GRO-066",
    "name": "Tetipac"
  },
  {
    "code": "MX-YUC-087",
    "name": "Tetiz"
  },
  {
    "code": "MX-TLA-048",
    "name": "Tetla de la Solidaridad"
  },
  {
    "code": "MX-TLA-049",
    "name": "Tetlatlahuca"
  },
  {
    "code": "MX-JAL-096",
    "name": "Teuchitlán"
  },
  {
    "code": "MX-MEX-099",
    "name": "Texcaltitlán"
  },
  {
    "code": "MX-MEX-100",
    "name": "Texcalyacac"
  },
  {
    "code": "MX-VER-173",
    "name": "Texcatepec"
  },
  {
    "code": "MX-MEX-101",
    "name": "Texcoco"
  },
  {
    "code": "MX-VER-174",
    "name": "Texhuacán"
  },
  {
    "code": "MX-VER-175",
    "name": "Texistepec"
  },
  {
    "code": "MX-YUC-088",
    "name": "Teya"
  },
  {
    "code": "MX-PUE-174",
    "name": "Teziutlán"
  },
  {
    "code": "MX-VER-176",
    "name": "Tezonapa"
  },
  {
    "code": "MX-HID-077",
    "name": "Tezontepec"
  },
  {
    "code": "MX-HID-066",
    "name": "Tezontepec de Aldama"
  },
  {
    "code": "MX-MEX-102",
    "name": "Tezoyuca"
  },
  {
    "code": "MX-ZAC-047",
    "name": "Teúl de González Ortega"
  },
  {
    "code": "MX-PUE-175",
    "name": "Tianguismanalco"
  },
  {
    "code": "MX-MEX-103",
    "name": "Tianguistenco"
  },
  {
    "code": "MX-HID-067",
    "name": "Tianguistengo"
  },
  {
    "code": "MX-YUC-089",
    "name": "Ticul"
  },
  {
    "code": "MX-GUA-040",
    "name": "Tierra Blanca"
  },
  {
    "code": "MX-VER-177",
    "name": "Tierra Blanca"
  },
  {
    "code": "MX-SLP-046",
    "name": "Tierra Nueva"
  },
  {
    "code": "MX-VER-178",
    "name": "Tihuatlán"
  },
  {
    "code": "MX-BCN-005",
    "name": "Tijuana"
  },
  {
    "code": "MX-CHP-104",
    "name": "Tila"
  },
  {
    "code": "MX-PUE-176",
    "name": "Tilapa"
  },
  {
    "code": "MX-MEX-104",
    "name": "Timilpan"
  },
  {
    "code": "MX-YUC-090",
    "name": "Timucuy"
  },
  {
    "code": "MX-MIC-090",
    "name": "Tingambato"
  },
  {
    "code": "MX-MIC-091",
    "name": "Tingüindín"
  },
  {
    "code": "MX-YUC-091",
    "name": "Tinum"
  },
  {
    "code": "MX-MIC-092",
    "name": "Tiquicheo"
  },
  {
    "code": "MX-YUC-092",
    "name": "Tixcacalcupul"
  },
  {
    "code": "MX-YUC-093",
    "name": "Tixkokob"
  },
  {
    "code": "MX-YUC-094",
    "name": "Tixmehuac"
  },
  {
    "code": "MX-YUC-095",
    "name": "Tixpéhual"
  },
  {
    "code": "MX-GRO-067",
    "name": "Tixtla de Guerrero"
  },
  {
    "code": "MX-JAL-097",
    "name": "Tizapán el Alto"
  },
  {
    "code": "MX-HID-068",
    "name": "Tizayuca"
  },
  {
    "code": "MX-YUC-096",
    "name": "Tizimín"
  },
  {
    "code": "MX-VER-179",
    "name": "Tlachichilco"
  },
  {
    "code": "MX-PUE-177",
    "name": "Tlachichuca"
  },
  {
    "code": "MX-GRO-068",
    "name": "Tlacoachistlahuaca"
  },
  {
    "code": "MX-GRO-069",
    "name": "Tlacoapa"
  },
  {
    "code": "MX-VER-180",
    "name": "Tlacojalpan"
  },
  {
    "code": "MX-OAX-024",
    "name": "Tlacolula"
  },
  {
    "code": "MX-VER-181",
    "name": "Tlacolulan"
  },
  {
    "code": "MX-VER-182",
    "name": "Tlacotalpan"
  },
  {
    "code": "MX-PUE-178",
    "name": "Tlacotepec de Benito Juárez"
  },
  {
    "code": "MX-VER-183",
    "name": "Tlacotepec de Mejía"
  },
  {
    "code": "MX-PUE-179",
    "name": "Tlacuilotepec"
  },
  {
    "code": "MX-DUR-037",
    "name": "Tlahualilo"
  },
  {
    "code": "MX-PUE-180",
    "name": "Tlahuapan"
  },
  {
    "code": "MX-HID-069",
    "name": "Tlahuelilpan"
  },
  {
    "code": "MX-HID-070",
    "name": "Tlahuiltepa"
  },
  {
    "code": "MX-JAL-098",
    "name": "Tlajomulco de Zúñiga"
  },
  {
    "code": "MX-GRO-070",
    "name": "Tlalchapa"
  },
  {
    "code": "MX-VER-184",
    "name": "Tlalixcoyan"
  },
  {
    "code": "MX-GRO-071",
    "name": "Tlalixtaquilla"
  },
  {
    "code": "MX-MEX-105",
    "name": "Tlalmanalco"
  },
  {
    "code": "MX-VER-185",
    "name": "Tlalnelhuayocan"
  },
  {
    "code": "MX-MOR-024",
    "name": "Tlalnepantla"
  },
  {
    "code": "MX-MEX-106",
    "name": "Tlalnepantla de Baz"
  },
  {
    "code": "MX-DIF-012",
    "name": "Tlalpan"
  },
  {
    "code": "MX-MIC-093",
    "name": "Tlalpujahua"
  },
  {
    "code": "MX-PUE-181",
    "name": "Tlaltenango"
  },
  {
    "code": "MX-ZAC-048",
    "name": "Tlaltenango de Sánchez Román"
  },
  {
    "code": "MX-VER-186",
    "name": "Tlaltetela"
  },
  {
    "code": "MX-MOR-025",
    "name": "Tlaltizapán"
  },
  {
    "code": "MX-HID-071",
    "name": "Tlanalapa"
  },
  {
    "code": "MX-HID-072",
    "name": "Tlanchinol"
  },
  {
    "code": "MX-PUE-182",
    "name": "Tlanepantla"
  },
  {
    "code": "MX-PUE-183",
    "name": "Tlaola"
  },
  {
    "code": "MX-GRO-072",
    "name": "Tlapa de Comonfort"
  },
  {
    "code": "MX-PUE-184",
    "name": "Tlapacoya"
  },
  {
    "code": "MX-VER-187",
    "name": "Tlapacoyan"
  },
  {
    "code": "MX-PUE-185",
    "name": "Tlapanalá"
  },
  {
    "code": "MX-GRO-073",
    "name": "Tlapehuala"
  },
  {
    "code": "MX-JAL-099",
    "name": "Tlaquepaque"
  },
  {
    "code": "MX-VER-188",
    "name": "Tlaquilpa"
  },
  {
    "code": "MX-MOR-026",
    "name": "Tlaquiltenango"
  },
  {
    "code": "MX-PUE-186",
    "name": "Tlatlauquitepec"
  },
  {
    "code": "MX-MEX-107",
    "name": "Tlatlaya"
  },
  {
    "code": "MX-TLA-050",
    "name": "Tlaxcala"
  },
  {
    "code": "MX-TLA-051",
    "name": "Tlaxco"
  },
  {
    "code": "MX-PUE-187",
    "name": "Tlaxco"
  },
  {
    "code": "MX-HID-073",
    "name": "Tlaxcoapan"
  },
  {
    "code": "MX-OAX-025",
    "name": "Tlaxiaco"
  },
  {
    "code": "MX-MOR-027",
    "name": "Tlayacapan"
  },
  {
    "code": "MX-MIC-094",
    "name": "Tlazazalca"
  },
  {
    "code": "MX-VER-189",
    "name": "Tlilapan"
  },
  {
    "code": "MX-DIF-013",
    "name": "Tláhuac"
  },
  {
    "code": "MX-TLA-052",
    "name": "Tocatlán"
  },
  {
    "code": "MX-PUE-188",
    "name": "Tochimilco"
  },
  {
    "code": "MX-PUE-189",
    "name": "Tochtepec"
  },
  {
    "code": "MX-MIC-095",
    "name": "Tocumbo"
  },
  {
    "code": "MX-HID-074",
    "name": "Tolcayuca"
  },
  {
    "code": "MX-QUE-018",
    "name": "Tolimán"
  },
  {
    "code": "MX-JAL-100",
    "name": "Tolimán"
  },
  {
    "code": "MX-MEX-108",
    "name": "Toluca"
  },
  {
    "code": "MX-VER-190",
    "name": "Tomatlán"
  },
  {
    "code": "MX-JAL-101",
    "name": "Tomatlán"
  },
  {
    "code": "MX-CHP-105",
    "name": "Tonalá"
  },
  {
    "code": "MX-JAL-102",
    "name": "Tonalá"
  },
  {
    "code": "MX-MEX-109",
    "name": "Tonanitla"
  },
  {
    "code": "MX-MEX-110",
    "name": "Tonatico"
  },
  {
    "code": "MX-JAL-103",
    "name": "Tonaya"
  },
  {
    "code": "MX-VER-191",
    "name": "Tonayán"
  },
  {
    "code": "MX-JAL-104",
    "name": "Tonila"
  },
  {
    "code": "MX-DUR-038",
    "name": "Topia"
  },
  {
    "code": "MX-COA-035",
    "name": "Torreón"
  },
  {
    "code": "MX-JAL-105",
    "name": "Totatiche"
  },
  {
    "code": "MX-TLA-053",
    "name": "Totolac"
  },
  {
    "code": "MX-CHP-106",
    "name": "Totolapa"
  },
  {
    "code": "MX-MOR-028",
    "name": "Totolapan"
  },
  {
    "code": "MX-PUE-190",
    "name": "Totoltepec de Guerrero"
  },
  {
    "code": "MX-JAL-106",
    "name": "Tototlán"
  },
  {
    "code": "MX-VER-192",
    "name": "Totutla"
  },
  {
    "code": "MX-ZAC-049",
    "name": "Trancoso"
  },
  {
    "code": "MX-VER-193",
    "name": "Tres Valles"
  },
  {
    "code": "MX-SON-067",
    "name": "Trincheras"
  },
  {
    "code": "MX-ZAC-050",
    "name": "Trinidad García de la Cadena"
  },
  {
    "code": "MX-SON-068",
    "name": "Tubutama"
  },
  {
    "code": "MX-TAM-039",
    "name": "Tula"
  },
  {
    "code": "MX-HID-075",
    "name": "Tula de Allende"
  },
  {
    "code": "MX-HID-076",
    "name": "Tulancingo"
  },
  {
    "code": "MX-HID-055",
    "name": "Tulantepec de Lugo Guerrero"
  },
  {
    "code": "MX-PUE-191",
    "name": "Tulcingo"
  },
  {
    "code": "MX-MEX-111",
    "name": "Tultepec"
  },
  {
    "code": "MX-MEX-112",
    "name": "Tultitlán"
  },
  {
    "code": "MX-ROO-009",
    "name": "Tulum"
  },
  {
    "code": "MX-CHP-107",
    "name": "Tumbalá"
  },
  {
    "code": "MX-MIC-096",
    "name": "Tumbiscatío"
  },
  {
    "code": "MX-YUC-097",
    "name": "Tunkás"
  },
  {
    "code": "MX-MIC-097",
    "name": "Turicato"
  },
  {
    "code": "MX-JAL-107",
    "name": "Tuxcacuesco"
  },
  {
    "code": "MX-JAL-108",
    "name": "Tuxcueca"
  },
  {
    "code": "MX-JAL-109",
    "name": "Tuxpan"
  },
  {
    "code": "MX-VER-194",
    "name": "Tuxpan"
  },
  {
    "code": "MX-NAY-019",
    "name": "Tuxpan"
  },
  {
    "code": "MX-MIC-098",
    "name": "Tuxpan"
  },
  {
    "code": "MX-OAX-026",
    "name": "Tuxtepec"
  },
  {
    "code": "MX-VER-195",
    "name": "Tuxtilla"
  },
  {
    "code": "MX-CHP-108",
    "name": "Tuxtla Chico"
  },
  {
    "code": "MX-CHP-109",
    "name": "Tuxtla Gutiérrez"
  },
  {
    "code": "MX-PUE-192",
    "name": "Tuzamapan de Galeana"
  },
  {
    "code": "MX-MIC-099",
    "name": "Tuzantla"
  },
  {
    "code": "MX-CHP-110",
    "name": "Tuzantán"
  },
  {
    "code": "MX-PUE-193",
    "name": "Tzicatlacoyan"
  },
  {
    "code": "MX-CHP-111",
    "name": "Tzimol"
  },
  {
    "code": "MX-MIC-100",
    "name": "Tzintzuntzan"
  },
  {
    "code": "MX-MIC-101",
    "name": "Tzitzio"
  },
  {
    "code": "MX-TLA-054",
    "name": "Tzompantepec"
  },
  {
    "code": "MX-YUC-098",
    "name": "Tzucacab"
  },
  {
    "code": "MX-GRO-074",
    "name": "Técpan de Galeana"
  },
  {
    "code": "MX-YUC-099",
    "name": "Uayma"
  },
  {
    "code": "MX-YUC-100",
    "name": "Ucú"
  },
  {
    "code": "MX-YUC-101",
    "name": "Umán"
  },
  {
    "code": "MX-JAL-110",
    "name": "Unión de San Antonio"
  },
  {
    "code": "MX-JAL-111",
    "name": "Unión de Tula"
  },
  {
    "code": "MX-CHP-112",
    "name": "Unión Juárez"
  },
  {
    "code": "MX-SON-069",
    "name": "Ures"
  },
  {
    "code": "MX-GUA-041",
    "name": "Uriangato"
  },
  {
    "code": "MX-CHH-065",
    "name": "Urique"
  },
  {
    "code": "MX-VER-196",
    "name": "Ursulo Galván"
  },
  {
    "code": "MX-CHH-066",
    "name": "Uruachi"
  },
  {
    "code": "MX-MIC-102",
    "name": "Uruapan"
  },
  {
    "code": "MX-VER-197",
    "name": "Uxpanapa"
  },
  {
    "code": "MX-YUC-102",
    "name": "Valladolid"
  },
  {
    "code": "MX-MEX-113",
    "name": "Valle de Bravo"
  },
  {
    "code": "MX-MEX-020",
    "name": "Valle de Chalco"
  },
  {
    "code": "MX-MEX-114",
    "name": "Valle de Chalco Solidaridad"
  },
  {
    "code": "MX-JAL-112",
    "name": "Valle de Guadalupe"
  },
  {
    "code": "MX-JAL-113",
    "name": "Valle de Juárez"
  },
  {
    "code": "MX-GUA-042",
    "name": "Valle de Santiago"
  },
  {
    "code": "MX-CHH-067",
    "name": "Valle de Zaragoza"
  },
  {
    "code": "MX-TAM-040",
    "name": "Valle Hermoso"
  },
  {
    "code": "MX-NLE-050",
    "name": "Vallecillo"
  },
  {
    "code": "MX-ZAC-051",
    "name": "Valparaíso"
  },
  {
    "code": "MX-SLP-047",
    "name": "Vanegas"
  },
  {
    "code": "MX-VER-198",
    "name": "Vega de Alatorre"
  },
  {
    "code": "MX-SLP-048",
    "name": "Venado"
  },
  {
    "code": "MX-CHP-113",
    "name": "Venustiano Carranza"
  },
  {
    "code": "MX-DIF-014",
    "name": "Venustiano Carranza"
  },
  {
    "code": "MX-PUE-194",
    "name": "Venustiano Carranza"
  },
  {
    "code": "MX-MIC-103",
    "name": "Venustiano Carranza"
  },
  {
    "code": "MX-VER-199",
    "name": "Veracruz"
  },
  {
    "code": "MX-ZAC-052",
    "name": "Vetagrande"
  },
  {
    "code": "MX-DUR-039",
    "name": "Vicente Guerrero"
  },
  {
    "code": "MX-PUE-195",
    "name": "Vicente Guerrero"
  },
  {
    "code": "MX-GUA-043",
    "name": "Victoria"
  },
  {
    "code": "MX-TAM-041",
    "name": "Victoria"
  },
  {
    "code": "MX-COA-036",
    "name": "Viesca"
  },
  {
    "code": "MX-VER-200",
    "name": "Villa Aldama"
  },
  {
    "code": "MX-JAL-126",
    "name": "Villa Alta"
  },
  {
    "code": "MX-ZAC-059",
    "name": "Villa Alta"
  },
  {
    "code": "MX-OAX-027",
    "name": "Villa Alta"
  },
  {
    "code": "MX-SON-073",
    "name": "Villa Alta"
  },
  {
    "code": "MX-SLP-059",
    "name": "Villa Alta"
  },
  {
    "code": "MX-CHP-114",
    "name": "Villa Comaltitlán"
  },
  {
    "code": "MX-JAL-114",
    "name": "Villa Corona"
  },
  {
    "code": "MX-CHP-115",
    "name": "Villa Corzo"
  },
  {
    "code": "MX-MEX-117",
    "name": "Villa de Allende"
  },
  {
    "code": "MX-SLP-051",
    "name": "Villa de Arista"
  },
  {
    "code": "MX-SLP-052",
    "name": "Villa de Arriaga"
  },
  {
    "code": "MX-ZAC-056",
    "name": "Villa de Cos"
  },
  {
    "code": "MX-SLP-053",
    "name": "Villa de Guadalupe"
  },
  {
    "code": "MX-SLP-056",
    "name": "Villa de la Paz"
  },
  {
    "code": "MX-SLP-054",
    "name": "Villa de Ramos"
  },
  {
    "code": "MX-SLP-055",
    "name": "Villa de Reyes"
  },
  {
    "code": "MX-COL-010",
    "name": "Villa de Álvarez"
  },
  {
    "code": "MX-MEX-118",
    "name": "Villa del Carbón"
  },
  {
    "code": "MX-ZAC-053",
    "name": "Villa García"
  },
  {
    "code": "MX-ZAC-054",
    "name": "Villa González Ortega"
  },
  {
    "code": "MX-JAL-115",
    "name": "Villa Guerrero"
  },
  {
    "code": "MX-MEX-115",
    "name": "Villa Guerrero"
  },
  {
    "code": "MX-JAL-116",
    "name": "Villa Hidalgo"
  },
  {
    "code": "MX-ZAC-055",
    "name": "Villa Hidalgo"
  },
  {
    "code": "MX-SON-070",
    "name": "Villa Hidalgo"
  },
  {
    "code": "MX-SLP-049",
    "name": "Villa Hidalgo"
  },
  {
    "code": "MX-SLP-050",
    "name": "Villa Juárez"
  },
  {
    "code": "MX-SON-071",
    "name": "Villa Pesqueira"
  },
  {
    "code": "MX-JAL-117",
    "name": "Villa Purificación"
  },
  {
    "code": "MX-COA-037",
    "name": "Villa Unión"
  },
  {
    "code": "MX-MEX-116",
    "name": "Villa Victoria"
  },
  {
    "code": "MX-CHP-116",
    "name": "Villaflores"
  },
  {
    "code": "MX-GUA-044",
    "name": "Villagrán"
  },
  {
    "code": "MX-TAM-042",
    "name": "Villagrán"
  },
  {
    "code": "MX-NLE-051",
    "name": "Villaldama"
  },
  {
    "code": "MX-MIC-104",
    "name": "Villamar"
  },
  {
    "code": "MX-ZAC-057",
    "name": "Villanueva"
  },
  {
    "code": "MX-MIC-105",
    "name": "Vista Hermosa"
  },
  {
    "code": "MX-VER-201",
    "name": "Xalapa"
  },
  {
    "code": "MX-MEX-119",
    "name": "Xalatlaco"
  },
  {
    "code": "MX-NAY-020",
    "name": "Xalisco"
  },
  {
    "code": "MX-TLA-055",
    "name": "Xaloztoc"
  },
  {
    "code": "MX-GRO-075",
    "name": "Xalpatláhuac"
  },
  {
    "code": "MX-TLA-056",
    "name": "Xaltocan"
  },
  {
    "code": "MX-PUE-196",
    "name": "Xayacatlán de Bravo"
  },
  {
    "code": "MX-GUA-045",
    "name": "Xichú"
  },
  {
    "code": "MX-VER-202",
    "name": "Xico"
  },
  {
    "code": "MX-TLA-057",
    "name": "Xicohtzinco"
  },
  {
    "code": "MX-PUE-197",
    "name": "Xicotepec"
  },
  {
    "code": "MX-PUE-198",
    "name": "Xicotlán"
  },
  {
    "code": "MX-TAM-043",
    "name": "Xicoténcatl"
  },
  {
    "code": "MX-SLP-057",
    "name": "Xilitla"
  },
  {
    "code": "MX-PUE-199",
    "name": "Xiutetelco"
  },
  {
    "code": "MX-YUC-103",
    "name": "Xocchel"
  },
  {
    "code": "MX-PUE-200",
    "name": "Xochiapulco"
  },
  {
    "code": "MX-HID-078",
    "name": "Xochiatipan"
  },
  {
    "code": "MX-HID-079",
    "name": "Xochicoatlán"
  },
  {
    "code": "MX-GRO-076",
    "name": "Xochihuehuetlán"
  },
  {
    "code": "MX-PUE-201",
    "name": "Xochiltepec"
  },
  {
    "code": "MX-DIF-015",
    "name": "Xochimilco"
  },
  {
    "code": "MX-GRO-077",
    "name": "Xochistlahuaca"
  },
  {
    "code": "MX-MOR-029",
    "name": "Xochitepec"
  },
  {
    "code": "MX-PUE-203",
    "name": "Xochitlán de Vicente Suárez"
  },
  {
    "code": "MX-PUE-202",
    "name": "Xochitlán Todos Santos"
  },
  {
    "code": "MX-MEX-120",
    "name": "Xonacatlán"
  },
  {
    "code": "MX-VER-203",
    "name": "Xoxocotla"
  },
  {
    "code": "MX-HID-080",
    "name": "Yahualica"
  },
  {
    "code": "MX-JAL-118",
    "name": "Yahualica de González Gallo"
  },
  {
    "code": "MX-CHP-117",
    "name": "Yajalón"
  },
  {
    "code": "MX-VER-204",
    "name": "Yanga"
  },
  {
    "code": "MX-PUE-204",
    "name": "Yaonáhuac"
  },
  {
    "code": "MX-TLA-058",
    "name": "Yauhquemehcan"
  },
  {
    "code": "MX-OAX-028",
    "name": "Yautepec"
  },
  {
    "code": "MX-MOR-030",
    "name": "Yautepec"
  },
  {
    "code": "MX-YUC-104",
    "name": "Yaxcabá"
  },
  {
    "code": "MX-YUC-105",
    "name": "Yaxkukul"
  },
  {
    "code": "MX-MOR-031",
    "name": "Yecapixtla"
  },
  {
    "code": "MX-VER-205",
    "name": "Yecuatla"
  },
  {
    "code": "MX-PUE-205",
    "name": "Yehualtepec"
  },
  {
    "code": "MX-YUC-106",
    "name": "Yobaín"
  },
  {
    "code": "MX-GUA-046",
    "name": "Yuriria"
  },
  {
    "code": "MX-MIC-106",
    "name": "Yurécuaro"
  },
  {
    "code": "MX-SON-072",
    "name": "Yécora"
  },
  {
    "code": "MX-OAX-029",
    "name": "Zaachila"
  },
  {
    "code": "MX-PUE-206",
    "name": "Zacapala"
  },
  {
    "code": "MX-PUE-207",
    "name": "Zacapoaxtla"
  },
  {
    "code": "MX-MIC-107",
    "name": "Zacapu"
  },
  {
    "code": "MX-ZAC-058",
    "name": "Zacatecas"
  },
  {
    "code": "MX-TLA-059",
    "name": "Zacatelco"
  },
  {
    "code": "MX-MOR-032",
    "name": "Zacatepec"
  },
  {
    "code": "MX-PUE-208",
    "name": "Zacatlán"
  },
  {
    "code": "MX-MEX-121",
    "name": "Zacazonapan"
  },
  {
    "code": "MX-JAL-119",
    "name": "Zacoalco de Torres"
  },
  {
    "code": "MX-MEX-122",
    "name": "Zacualpan"
  },
  {
    "code": "MX-VER-206",
    "name": "Zacualpan"
  },
  {
    "code": "MX-MOR-033",
    "name": "Zacualpan"
  },
  {
    "code": "MX-HID-081",
    "name": "Zacualtipán de Ángeles"
  },
  {
    "code": "MX-MIC-108",
    "name": "Zamora"
  },
  {
    "code": "MX-JAL-120",
    "name": "Zapopan"
  },
  {
    "code": "MX-JAL-121",
    "name": "Zapotiltic"
  },
  {
    "code": "MX-PUE-209",
    "name": "Zapotitlán"
  },
  {
    "code": "MX-PUE-210",
    "name": "Zapotitlán de Méndez"
  },
  {
    "code": "MX-JAL-122",
    "name": "Zapotitlán de Vadillo"
  },
  {
    "code": "MX-GRO-078",
    "name": "Zapotitlán Tablas"
  },
  {
    "code": "MX-JAL-123",
    "name": "Zapotlanejo"
  },
  {
    "code": "MX-HID-082",
    "name": "Zapotlán de Juárez"
  },
  {
    "code": "MX-JAL-124",
    "name": "Zapotlán del Rey"
  },
  {
    "code": "MX-JAL-125",
    "name": "Zapotlán el Grande"
  },
  {
    "code": "MX-COA-038",
    "name": "Zaragoza"
  },
  {
    "code": "MX-VER-207",
    "name": "Zaragoza"
  },
  {
    "code": "MX-PUE-211",
    "name": "Zaragoza"
  },
  {
    "code": "MX-SLP-058",
    "name": "Zaragoza"
  },
  {
    "code": "MX-PUE-212",
    "name": "Zautla"
  },
  {
    "code": "MX-HID-083",
    "name": "Zempoala"
  },
  {
    "code": "MX-VER-208",
    "name": "Zentla"
  },
  {
    "code": "MX-GRO-079",
    "name": "Zihuatanejo de Azueta"
  },
  {
    "code": "MX-PUE-213",
    "name": "Zihuateutla"
  },
  {
    "code": "MX-HID-084",
    "name": "Zimapán"
  },
  {
    "code": "MX-OAX-030",
    "name": "Zimatlán"
  },
  {
    "code": "MX-MEX-123",
    "name": "Zinacantepec"
  },
  {
    "code": "MX-CHP-118",
    "name": "Zinacantán"
  },
  {
    "code": "MX-PUE-214",
    "name": "Zinacatepec"
  },
  {
    "code": "MX-MIC-109",
    "name": "Zinapécuaro"
  },
  {
    "code": "MX-MIC-110",
    "name": "Zináparo"
  },
  {
    "code": "MX-MIC-111",
    "name": "Ziracuaretiro"
  },
  {
    "code": "MX-GRO-080",
    "name": "Zirándaro"
  },
  {
    "code": "MX-GRO-081",
    "name": "Zitlala"
  },
  {
    "code": "MX-TLA-060",
    "name": "Zitlaltepec de Trinidad Sánchez Santos"
  },
  {
    "code": "MX-MIC-112",
    "name": "Zitácuaro"
  },
  {
    "code": "MX-VER-209",
    "name": "Zongolica"
  },
  {
    "code": "MX-PUE-215",
    "name": "Zongozotla"
  },
  {
    "code": "MX-VER-210",
    "name": "Zontecomatlán de López y Fuentes"
  },
  {
    "code": "MX-PUE-216",
    "name": "Zoquiapan"
  },
  {
    "code": "MX-PUE-217",
    "name": "Zoquitlán"
  },
  {
    "code": "MX-VER-211",
    "name": "Zozocolco de Hidalgo"
  },
  {
    "code": "MX-MEX-124",
    "name": "Zumpahuacán"
  },
  {
    "code": "MX-MEX-125",
    "name": "Zumpango"
  },
  {
    "code": "MX-VER-212",
    "name": "Álamo Temapache"
  },
  {
    "code": "MX-DIF-016",
    "name": "Álvaro Obregón"
  },
  {
    "code": "MX-MIC-113",
    "name": "Álvaro Obregón"
  }
]